//@ts-nocheck
/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * MetaIS Monitoring
 * OpenAPI spec version: latest
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
    MutationFunction,
    QueryFunction,
    QueryKey,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { useCallback } from 'react'
import { useMonitoringSwaggerClient } from '../hooks/useMonitoringSwaggerClient'
export type FindActiveMonitoringCfgParams = {
    isvsUuid?: string
    page?: number
    pageSize?: number
}

export type FindActiveMonitoringLogByInterval1Params = {
    isvsUuid: string
    intervalStart: string
    intervalEnd: string
}

export type FindActiveMonitoringLogByIntervalParams = {
    intervalStart: string
    intervalEnd: string
}

export type FindActiveMonitoringLogParams = {
    activeMonitoringCfgId: number
    page?: number
    pageSize?: number
}

export type FindActiveMonitoringLogFailNoteParams = {
    activeMonitoringLogId: number
    page?: number
    pageSize?: number
}

export type ListOlaContractListParams = {
    contractCode?: string
    name?: string
    contractorIsvsUuid?: string
    metaIsCode?: string
    validityStart?: string
    validityEnd?: string
    liableEntities?: string[]
    page?: number
    perPageSize?: number
    sortBy?: string
    ascending?: boolean
    onlyDraftState?: boolean
}

export type ListRelatedParameterTypesParams = {
    ignoreNoDateIntersection?: boolean
    page?: number
    perPageSize?: number
    sortBy?: string
    ascending?: boolean
}

export type CheckRequiredSlaParametersParams = {
    slaContractUuid: string
    parameterTypeCategory: string
    page?: number
    perPageSize?: number
    sortBy?: string
    ascending?: boolean
}

export type ListCreateContractCandidatesParams = {
    provProjects?: string[]
    provIsvss?: string[]
    consProjects?: string[]
    consIsvsNameLike?: string
    provIsvsNameLike?: string
    page?: number
    perPageSize?: number
    sortBy?: string
    ascending?: boolean
}

export type ListSlaContractsParams = {
    name?: string
    phase?: string
    consumerProjectUuid?: string
    consumerServiceUuid?: string
    consumerMainPersonUuid?: string
    providerProjectUuid?: string
    providerServiceUuid?: string
    providerMainPersonUuid?: string
    intervalStart?: string
    intervalEnd?: string
    statusFilter?: string
    page?: number
    perPageSize?: number
    sortBy?: string
    ascending?: boolean
    onlyDraftState?: boolean
}

export type CheckOperationPermissionByMetaisCodeParams = {
    operation: string
}

export type ListParameterTypesParams = {
    serviceType: string
    paramType?: string
    valueType?: string
    services?: string[]
    ignoreNonActual?: boolean
    page?: number
    perPageSize?: number
    sortBy?: string
    ascending?: boolean
}

export type Echo200 = { [key: string]: unknown }

export type EchoParams = {
    param?: string
}

export type GetAnyDouble200 = { [key: string]: unknown }

export type GetAnyList200 = { [key: string]: unknown }

export type GetAnyObject200 = { [key: string]: unknown }

export type GetAnyString200 = { [key: string]: unknown }

export type GetCurrentDate200 = { [key: string]: unknown }

export type ImportReportBody = {
    file: Blob
}

export type ImportMonitorParametersBody = {
    file: Blob
}

export type ValidateMonitorParametersBody = {
    file: Blob
}

export type ValidateReportBody = {
    file: Blob
}

export type ListParameterTypes1Params = {
    category?: string
    ignoreNonActual?: boolean
    filterRequiredOnly?: boolean
    page?: number
    perPageSize?: number
}

export type ExportParameterValuesParams = {
    filter: ExportParameterValuesFilter
}

export interface ApiActiveMonitoringResult {
    body?: string
    bodyOk?: boolean
    cfgErrorMessage?: string
    status?: string
    statusOk?: boolean
}

export interface ApiActiveMonitoringCfgList {
    pagination?: PaginationResponseData
    results?: ApiActiveMonitoringCfg[]
}

export type ApiActiveMonitoringExtendedLogStatus = (typeof ApiActiveMonitoringExtendedLogStatus)[keyof typeof ApiActiveMonitoringExtendedLogStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiActiveMonitoringExtendedLogStatus = {
    ALIVE: 'ALIVE',
    DEAD: 'DEAD',
} as const

export interface ApiActiveMonitoringExtendedLog {
    httpUrl?: string
    id?: number
    intervalEnd?: string
    intervalStart?: string
    status?: ApiActiveMonitoringExtendedLogStatus
}

export interface ApiActiveMonitoringAvaliability {
    items?: ApiActiveMonitoringExtendedLog[]
}

export type ApiActiveMonitoringLogStatus = (typeof ApiActiveMonitoringLogStatus)[keyof typeof ApiActiveMonitoringLogStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiActiveMonitoringLogStatus = {
    ALIVE: 'ALIVE',
    DEAD: 'DEAD',
} as const

export interface ApiActiveMonitoringLog {
    id?: number
    intervalEnd?: string
    intervalStart?: string
    status?: ApiActiveMonitoringLogStatus
}

export interface ApiActiveMonitoringLogList {
    pagination?: PaginationResponseData
    results?: ApiActiveMonitoringLog[]
}

export interface ApiActiveMonitoringLogFailNote {
    date?: string
    id?: number
    note?: string
}

export interface ApiActiveMonitoringLogFailNoteList {
    pagination?: PaginationResponseData
    results?: ApiActiveMonitoringLogFailNote[]
}

export interface ApiOlaContractDataList {
    pagination?: PaginationResponseData
    results?: ApiOlaContractData[]
}

export interface ApiParameterTypesList {
    pagination?: PaginationResponseData
    results?: ApiParameterType[]
}

export interface ApiSlaParameter {
    type?: string
}

export interface ApiService {
    code?: string
    name?: string
    slaParameters?: ApiSlaParameter[]
    uuid?: string
}

export interface ApiServicesSlaParameters {
    pagination?: PaginationResponseData
    results?: ApiService[]
}

export interface ApiMonObjectInfoLight {
    code?: string
    name?: string
    owner?: string
    state?: string
    type?: string
    uuid?: string
}

export interface ApiContractCreateObjectCandidates {
    consIsvs?: ApiMonObjectInfoLight
    consProject?: ApiMonObjectInfoLight
    provIsvs?: ApiMonObjectInfoLight
    provProject?: ApiMonObjectInfoLight
}

export interface ApiContractCreateObjectCandidatesList {
    pagination?: PaginationResponseData
    results?: ApiContractCreateObjectCandidates[]
}

export interface ApiPermissionResult {
    hasPermission?: boolean
}

export interface ApiSlaContractReadMainPersonInfo {
    name?: string
    uuid?: string
}

export interface ApiSlaContractReadIsvsInfo {
    abbreviation?: string
    code?: string
    name?: string
    uuid?: string
}

export interface ApiSlaParameterReadServiceInfo {
    name?: string
    uuid?: string
}

export interface ApiSlaContractParameterRead {
    evaluationMethod?: string
    isValid?: boolean
    measurementMethod?: string
    note?: string
    owner?: string
    penaltyDescription?: string
    serviceInfo?: ApiSlaParameterReadServiceInfo
    slaParamTypeCode?: string
    uuid?: string
    value?: string
    valueType?: string
}

export interface ApiSlaContractRead {
    ciType?: string
    code?: string
    consumerIsvs?: ApiSlaContractReadIsvsInfo
    consumerIsvsMainPerson?: ApiSlaContractReadMainPersonInfo
    description?: string
    descriptionEnglish?: string
    indentificator?: string
    isLocked?: boolean
    name?: string
    nameEnglish?: string
    note?: string
    owner?: string
    phase?: string
    providerIsvs?: ApiSlaContractReadIsvsInfo
    providerIsvsMainPerson?: ApiSlaContractReadMainPersonInfo
    referencingIdentifier?: string
    slaParameters?: ApiSlaContractParameterRead[]
    source?: string
    state?: string
    subject?: string
    supportEscalationDescription?: string
    supportForm?: string
    supportFormOfContactOutsideWorkingHours?: string
    supportInfo?: string
    supportInstructions?: string
    supportMaximalResponseTime?: string
    supportMaximalResponseTimeOutsideWorkingHours?: string
    supportType?: string
    supportWorkingHours?: string
    type?: string
    uuid?: string
    validityEndDate?: string
    validityStartDate?: string
}

export interface ApiSlaContractReadList {
    pagination?: PaginationResponseData
    results?: ApiSlaContractRead[]
}

export interface ApiSlaParameterRead {
    evaluationMethod?: string
    isValid?: boolean
    measurementMethod?: string
    note?: string
    owner?: string
    penaltyDescription?: string
    serviceInfo?: ApiSlaParameterReadServiceInfo
    slaParamTypeCode?: string
    uuid?: string
    value?: string
    valueType?: string
}

export interface ApiSlaParameterReadList {
    pagination?: PaginationResponseData
    results?: ApiSlaParameterRead[]
}

export type AsyncTaskDtoState = (typeof AsyncTaskDtoState)[keyof typeof AsyncTaskDtoState]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AsyncTaskDtoState = {
    CREATED: 'CREATED',
    IN_PROGRESS: 'IN_PROGRESS',
    DONE: 'DONE',
    CANCELLED: 'CANCELLED',
    FAILED: 'FAILED',
} as const

export interface AsyncTaskDto {
    exception?: string
    finishedAt?: string
    processedItems?: number
    startAt?: string
    state?: AsyncTaskDtoState
    uuid?: string
}

export interface ApiActiveMonitoringReport {
    avaliability?: boolean
    cfgUrl?: string
    code?: string
    entityIsvsType?: string
    externalIntegration?: string
    isvsCode?: string
    isvsName?: string
    lastCheck?: string
    name?: string
    owner?: string
    poOperator?: string
    projectCode?: string
    projectName?: string
}

export interface ApiActiveMonitoringReportList {
    pagination?: PaginationResponseData
    results?: ApiActiveMonitoringReport[]
}

export interface ActiveMonitoringReportRequest {
    filtered?: string[]
    page?: number
    perPage?: number
    type?: string
}

export interface EnumItem {
    code?: string
    description?: string
    engDescription?: string
    engValue?: string
    id?: number
    orderList?: number
    qualifierKey?: string
    qualifierName?: string
    qualifierNameEng?: string
    valid?: boolean
    value?: string
}

export interface CurrentSystemState {
    createdAt?: string
    id?: number
    systemState?: EnumItem
    systemStateColor?: EnumItem
    text?: string
}

export interface CurrentSystemStateIn {
    systemState?: string
    systemStateColor?: string
    text?: string
}

export interface MainAttributes {
    name?: string
    uuid?: string
}

export interface ApiOlaContractISVS {
    uuid?: string
}

export interface ApiOlaContractData {
    administratorIsvs?: MainAttributes[]
    ciType?: string
    code?: string
    contractCode?: string
    /** @deprecated */
    contractorIsvsUuid?: string
    contractorIsvsUuids?: ApiOlaContractISVS[]
    crzLink?: string
    description?: string
    descriptionEnglish?: string
    documentName?: string
    name?: string
    nameEnglish?: string
    note?: string
    owner?: string
    profilState?: string
    referencingIdentifier?: string
    source?: string
    state?: string
    uuid?: string
    validityEndDate?: string
    validityStartDate?: string
    vendorLock?: boolean
}

export interface RequestIdUi {
    requestId?: string
}

export type ApiImportMonitoringReportsChannel = (typeof ApiImportMonitoringReportsChannel)[keyof typeof ApiImportMonitoringReportsChannel]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiImportMonitoringReportsChannel = {
    FORMUAR: 'FORMUAR',
    UPLOAD: 'UPLOAD',
    EDESK: 'EDESK',
    WEBSERVICE: 'WEBSERVICE',
    ACTIVE_MONITORING: 'ACTIVE_MONITORING',
} as const

export interface ApiImportMonitoringReport {
    name?: string
    report?: string[]
}

export interface ApiImportMonitoringReports {
    channel?: ApiImportMonitoringReportsChannel
    reports?: ApiImportMonitoringReport[]
}

export interface XmlImportResult {
    errMessages?: string[]
    imported?: boolean
    reportName?: string
}

export interface PoItemDto {
    name?: string
    uuid?: string
}

export interface ListMonitoredIsvsRequest {
    pagination?: Pagination
    serviceType?: string
}

export interface ListMultipleServiceParameterValuesRequest {
    deleted?: boolean
    entityIds?: string[]
    intervalEnd?: string
    intervalStart?: string
}

export type SortingDirection = (typeof SortingDirection)[keyof typeof SortingDirection]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SortingDirection = {
    ASC: 'ASC',
    DESC: 'DESC',
} as const

export interface Sorting {
    direction?: SortingDirection
    sortAttr?: string
}

export interface Pagination {
    page?: number
    perPageSize?: number
}

export interface ListMonitoringOverviewRequest {
    entityRef?: string
    includePoName?: boolean
    intervalEnd?: string
    intervalStart?: string
    isvsUuid?: string
    liableEntity?: string
    metaisCode?: string
    pagination?: Pagination
    serviceName?: string
    serviceTypes?: string[]
    sorting?: Sorting
}

export interface ListMonitoredValuesRequest {
    dateFrom?: string
    dateTo?: string
    pagination?: Pagination
    parameterTypeId?: number
    sorting?: Sorting
}

export interface MonitoredExportValue {
    isvsCode?: string
    parameterType?: ApiParameterType
    poCode?: string
    projectCode?: string
    serviceCode?: string
    serviceExtIntegration?: string
    serviceId?: string
    serviceType?: string
    value?: number
}

export interface MonitoredExportList {
    results?: MonitoredExportValue[]
}

export interface MonitoredExportRequest {
    intervalEnd?: string
    intervalStart?: string
    isvs?: string
    project?: string
    services?: string[]
    serviceType?: string
}

export type MonitorErrorType = (typeof MonitorErrorType)[keyof typeof MonitorErrorType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MonitorErrorType = {
    UN_KNOW_SERVICE_TYPE: 'UN_KNOW_SERVICE_TYPE',
    UN_KNOW_SERVICE: 'UN_KNOW_SERVICE',
    UN_KNOW_PARAMETER: 'UN_KNOW_PARAMETER',
    UN_KNOW_START_DATE: 'UN_KNOW_START_DATE',
    UN_KNOW_END_DATE: 'UN_KNOW_END_DATE',
    END_DATE_BEFORE_START: 'END_DATE_BEFORE_START',
    NOT_NUMBER: 'NOT_NUMBER',
    NEGATIVE_NUMBER: 'NEGATIVE_NUMBER',
    MISSING_VALUES: 'MISSING_VALUES',
    RIGHTS_ERROR: 'RIGHTS_ERROR',
    FILE_EMPTY: 'FILE_EMPTY',
    FILE_ERROR: 'FILE_ERROR',
} as const

export interface MonitorError {
    line?: number
    type?: MonitorErrorType
    value?: string
}

export interface ImportMonitoringResult {
    createTime?: string
    errMessages?: MonitorError[]
    numberOfItems?: number
    ok?: boolean
    reportName?: string
}

export interface XmlValidationResult {
    createTime?: string
    errMessages?: string[]
    isvs?: string
    numberOfItems?: number
    ok?: boolean
    reportName?: string
}

export interface ServiceDataHolder {
    serviceName?: string
    serviceSlaUuid?: string
    serviceSlaValue?: string
    serviceSlaValueType?: string
    serviceUuid?: string
}

export interface ApiSlaParameterWriteExtended {
    evaluationMethod?: string
    isValid?: boolean
    measurementMethod?: string
    note?: string
    overwriteSla?: boolean
    penaltyDescription?: string
    services?: ApiServiceData[]
    servicesWithSla?: ServiceDataHolder[]
    slaParamTypeCode?: string
    uuid?: string
    value?: string
    valueType?: string
}

export type ApiActiveMonitoringCfgHttpMethod = (typeof ApiActiveMonitoringCfgHttpMethod)[keyof typeof ApiActiveMonitoringCfgHttpMethod]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiActiveMonitoringCfgHttpMethod = {
    POST: 'POST',
    GET: 'GET',
} as const

export interface ApiActiveMonitoringCfg {
    createdAt?: string
    enabled?: boolean
    entityType?: string
    httpMethod?: ApiActiveMonitoringCfgHttpMethod
    httpRequestBody?: string
    httpRequestHeader?: string[][]
    httpResponseBodyRegex?: string
    httpResponseStatus?: string
    httpUrl?: string
    id?: number
    isvsName?: string
    isvsUuid?: string
    lastExecutionTime?: string
    periodicity?: string
}

export interface PaginationResponseData {
    page?: number
    perPage?: number
    totalItems?: number
    totalPages?: number
}

export interface MonitoredItemDto {
    entityId?: string
    entityName?: string
    entityNameEng?: string
    entityType?: string
    id?: number
    lastValueDate?: string
    metaisCode?: string
    poName?: string
    poUuid?: string
    valuesDateFrom?: string
    valuesDateTo?: string
}

export interface ListMonitoredIsvsResponse {
    isvs?: MonitoredItemDto[]
    pagination?: PaginationResponseData
    po?: PoItemDto[]
}

export interface MonitoredItemListDto {
    items?: MonitoredItemDto[]
    pagination?: PaginationResponseData
}

export interface MetaData {
    createdAt?: string
    createdBy?: string
    createdUsingChannel?: string
    lastModifiedAt?: string
    lastModifiedBy?: string
}

export interface NewMonitoredValueDto {
    from?: string
    id?: number
    monitoredItemUuid?: string
    parameterTypeId?: number
    to?: string
    value?: string
}

export interface AddMonitoredValueRequest {
    values?: NewMonitoredValueDto[]
}

export interface ApiParameterTypeValueConstraint {
    enumCode?: string
    maxValue?: number
    minValue?: number
    regularExpression?: string
}

export interface ApiParameterTypeMetaData {
    createdAt?: string
    createdBy?: string
    lastModifiedAt?: string
    lastModifiedBy?: string
}

export type ApiParameterTypeValueType = (typeof ApiParameterTypeValueType)[keyof typeof ApiParameterTypeValueType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiParameterTypeValueType = {
    BOOLEAN: 'BOOLEAN',
    NUMBER: 'NUMBER',
    STRING: 'STRING',
    ENUM: 'ENUM',
} as const

export interface ApiInterval {
    end?: string
    start?: string
}

export interface ApiParameterType {
    category?: string
    code?: string
    constraint?: ApiParameterTypeValueConstraint
    description?: string
    id?: number
    metaData?: ApiParameterTypeMetaData
    name?: string
    required?: boolean
    unit?: string
    validity?: ApiInterval
    valueType?: ApiParameterTypeValueType
}

export interface MonitoredValueDto {
    deleted?: boolean
    from?: string
    id?: number
    metaData?: MetaData
    monitoredItem?: MonitoredItemDto
    parameterType?: ApiParameterType
    to?: string
    value?: string
}

export interface MonitoredValueListDto {
    pagination?: PaginationResponseData
    results?: MonitoredValueDto[]
}

export interface ApiServiceData {
    owner?: string
    uuid?: string
}

export interface ApiSlaContractParameterWrite {
    evaluationMethod?: string
    isValid?: boolean
    measurementMethod?: string
    note?: string
    penaltyDescription?: string
    services?: ApiServiceData[]
    slaParamTypeCode?: string
    uuid?: string
    value?: string
    valueType?: string
}

export interface ApiSlaContractWrite {
    ciType?: string
    code?: string
    consumerServiceUuid?: string
    description?: string
    descriptionEnglish?: string
    indentificator?: string
    name?: string
    nameEnglish?: string
    note?: string
    owner?: string
    phase?: string
    providerServiceUuid?: string
    referencingIdentifier?: string
    slaParameters?: ApiSlaContractParameterWrite[]
    source?: string
    state?: string
    subject?: string
    supportEscalationDescription?: string
    supportForm?: string
    supportFormOfContactOutsideWorkingHours?: string
    supportInfo?: string
    supportInstructions?: string
    supportMaximalResponseTime?: string
    supportMaximalResponseTimeOutsideWorkingHours?: string
    supportType?: string
    supportWorkingHours?: string
    type?: string
    uuid?: string
    validityEndDate?: string
    validityStartDate?: string
}

export interface ApiSlaParameterWrite {
    evaluationMethod?: string
    isValid?: boolean
    measurementMethod?: string
    note?: string
    penaltyDescription?: string
    services?: ApiServiceData[]
    slaParamTypeCode?: string
    uuid?: string
    value?: string
    valueType?: string
}

export interface ExportParameterValuesResult {
    zipFile?: string[]
}

export interface ExportParameterValuesFilter {
    entityReferenceId?: string
    entityReferenceType?: string
    intervalEnd?: string
    intervalStart?: string
}

export type ApiErrorData = { [key: string]: unknown }

export interface ApiError {
    data?: ApiErrorData
    logToken?: string
    message?: string
    type?: string
    values?: string[]
}

type AwaitedInput<T> = PromiseLike<T> | T

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never

export const useExportParameterValuesHook = () => {
    const exportParameterValues = useMonitoringSwaggerClient<ExportParameterValuesResult>()

    return useCallback(
        (params: ExportParameterValuesParams, signal?: AbortSignal) => {
            return exportParameterValues({ url: `/param-value/exportParameterValues`, method: 'GET', params, signal })
        },
        [exportParameterValues],
    )
}

export const getExportParameterValuesQueryKey = (params: ExportParameterValuesParams) => {
    return [`/param-value/exportParameterValues`, ...(params ? [params] : [])] as const
}

export const useExportParameterValuesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useExportParameterValuesHook>>>, TError = ApiError>(
    params: ExportParameterValuesParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportParameterValuesHook>>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getExportParameterValuesQueryKey(params)

    const exportParameterValues = useExportParameterValuesHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useExportParameterValuesHook>>>> = ({ signal }) =>
        exportParameterValues(params, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useExportParameterValuesHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey }
}

export type ExportParameterValuesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useExportParameterValuesHook>>>>
export type ExportParameterValuesQueryError = ApiError

export function useExportParameterValues<TData = Awaited<ReturnType<ReturnType<typeof useExportParameterValuesHook>>>, TError = ApiError>(
    params: ExportParameterValuesParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportParameterValuesHook>>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useExportParameterValuesQueryOptions(params, options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useExportParameterValues1Hook = () => {
    const exportParameterValues1 = useMonitoringSwaggerClient<ExportParameterValuesResult>()

    return useCallback(
        (exportParameterValuesFilter: ExportParameterValuesFilter) => {
            return exportParameterValues1({
                url: `/param-value/exportParameterValues`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: exportParameterValuesFilter,
            })
        },
        [exportParameterValues1],
    )
}

export const useExportParameterValues1MutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useExportParameterValues1Hook>>>,
        TError,
        { data: ExportParameterValuesFilter },
        TContext
    >
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportParameterValues1Hook>>>,
    TError,
    { data: ExportParameterValuesFilter },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {}

    const exportParameterValues1 = useExportParameterValues1Hook()

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useExportParameterValues1Hook>>>,
        { data: ExportParameterValuesFilter }
    > = (props) => {
        const { data } = props ?? {}

        return exportParameterValues1(data)
    }

    return { mutationFn, ...mutationOptions }
}

export type ExportParameterValues1MutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useExportParameterValues1Hook>>>>
export type ExportParameterValues1MutationBody = ExportParameterValuesFilter
export type ExportParameterValues1MutationError = ApiError

export const useExportParameterValues1 = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useExportParameterValues1Hook>>>,
        TError,
        { data: ExportParameterValuesFilter },
        TContext
    >
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useExportParameterValues1Hook>>>,
    TError,
    { data: ExportParameterValuesFilter },
    TContext
> => {
    const mutationOptions = useExportParameterValues1MutationOptions(options)

    return useMutation(mutationOptions)
}

export const useUpdateSlaParamsHook = () => {
    const updateSlaParams = useMonitoringSwaggerClient<void>()

    return useCallback(
        (apiSlaParameterWrite: ApiSlaParameterWrite[]) => {
            return updateSlaParams({
                url: `/slaparams/updateslaparams`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: apiSlaParameterWrite,
            })
        },
        [updateSlaParams],
    )
}

export const useUpdateSlaParamsMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateSlaParamsHook>>>, TError, { data: ApiSlaParameterWrite[] }, TContext>
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateSlaParamsHook>>>, TError, { data: ApiSlaParameterWrite[] }, TContext> => {
    const { mutation: mutationOptions } = options ?? {}

    const updateSlaParams = useUpdateSlaParamsHook()

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateSlaParamsHook>>>, { data: ApiSlaParameterWrite[] }> = (
        props,
    ) => {
        const { data } = props ?? {}

        return updateSlaParams(data)
    }

    return { mutationFn, ...mutationOptions }
}

export type UpdateSlaParamsMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateSlaParamsHook>>>>
export type UpdateSlaParamsMutationBody = ApiSlaParameterWrite[]
export type UpdateSlaParamsMutationError = ApiError

export const useUpdateSlaParams = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateSlaParamsHook>>>, TError, { data: ApiSlaParameterWrite[] }, TContext>
}): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useUpdateSlaParamsHook>>>, TError, { data: ApiSlaParameterWrite[] }, TContext> => {
    const mutationOptions = useUpdateSlaParamsMutationOptions(options)

    return useMutation(mutationOptions)
}

export const useUpdateSlaContractHook = () => {
    const updateSlaContract = useMonitoringSwaggerClient<void>()

    return useCallback(
        (apiSlaContractWrite: ApiSlaContractWrite) => {
            return updateSlaContract({
                url: `/slacontract/update`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: apiSlaContractWrite,
            })
        },
        [updateSlaContract],
    )
}

export const useUpdateSlaContractMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateSlaContractHook>>>, TError, { data: ApiSlaContractWrite }, TContext>
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateSlaContractHook>>>, TError, { data: ApiSlaContractWrite }, TContext> => {
    const { mutation: mutationOptions } = options ?? {}

    const updateSlaContract = useUpdateSlaContractHook()

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateSlaContractHook>>>, { data: ApiSlaContractWrite }> = (props) => {
        const { data } = props ?? {}

        return updateSlaContract(data)
    }

    return { mutationFn, ...mutationOptions }
}

export type UpdateSlaContractMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateSlaContractHook>>>>
export type UpdateSlaContractMutationBody = ApiSlaContractWrite
export type UpdateSlaContractMutationError = ApiError

export const useUpdateSlaContract = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateSlaContractHook>>>, TError, { data: ApiSlaContractWrite }, TContext>
}): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useUpdateSlaContractHook>>>, TError, { data: ApiSlaContractWrite }, TContext> => {
    const mutationOptions = useUpdateSlaContractMutationOptions(options)

    return useMutation(mutationOptions)
}

export const useGetParameterTypeHook = () => {
    const getParameterType = useMonitoringSwaggerClient<ApiParameterType>()

    return useCallback(
        (parameterTypeCode: string, signal?: AbortSignal) => {
            return getParameterType({ url: `/paramtypes/${parameterTypeCode}`, method: 'GET', signal })
        },
        [getParameterType],
    )
}

export const getGetParameterTypeQueryKey = (parameterTypeCode: string) => {
    return [`/paramtypes/${parameterTypeCode}`] as const
}

export const useGetParameterTypeQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetParameterTypeHook>>>, TError = ApiError>(
    parameterTypeCode: string,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetParameterTypeHook>>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getGetParameterTypeQueryKey(parameterTypeCode)

    const getParameterType = useGetParameterTypeHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetParameterTypeHook>>>> = ({ signal }) =>
        getParameterType(parameterTypeCode, signal)

    return { queryKey, queryFn, enabled: !!parameterTypeCode, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetParameterTypeHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey }
}

export type GetParameterTypeQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetParameterTypeHook>>>>
export type GetParameterTypeQueryError = ApiError

export function useGetParameterType<TData = Awaited<ReturnType<ReturnType<typeof useGetParameterTypeHook>>>, TError = ApiError>(
    parameterTypeCode: string,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetParameterTypeHook>>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetParameterTypeQueryOptions(parameterTypeCode, options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useUpdateParameterTypeHook = () => {
    const updateParameterType = useMonitoringSwaggerClient<void>()

    return useCallback(
        (parameterTypeCode: string, apiParameterType: ApiParameterType) => {
            return updateParameterType({
                url: `/paramtypes/${parameterTypeCode}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: apiParameterType,
            })
        },
        [updateParameterType],
    )
}

export const useUpdateParameterTypeMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useUpdateParameterTypeHook>>>,
        TError,
        { parameterTypeCode: string; data: ApiParameterType },
        TContext
    >
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateParameterTypeHook>>>,
    TError,
    { parameterTypeCode: string; data: ApiParameterType },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {}

    const updateParameterType = useUpdateParameterTypeHook()

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useUpdateParameterTypeHook>>>,
        { parameterTypeCode: string; data: ApiParameterType }
    > = (props) => {
        const { parameterTypeCode, data } = props ?? {}

        return updateParameterType(parameterTypeCode, data)
    }

    return { mutationFn, ...mutationOptions }
}

export type UpdateParameterTypeMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateParameterTypeHook>>>>
export type UpdateParameterTypeMutationBody = ApiParameterType
export type UpdateParameterTypeMutationError = ApiError

export const useUpdateParameterType = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useUpdateParameterTypeHook>>>,
        TError,
        { parameterTypeCode: string; data: ApiParameterType },
        TContext
    >
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useUpdateParameterTypeHook>>>,
    TError,
    { parameterTypeCode: string; data: ApiParameterType },
    TContext
> => {
    const mutationOptions = useUpdateParameterTypeMutationOptions(options)

    return useMutation(mutationOptions)
}

export const useDeleteParameterTypeHook = () => {
    const deleteParameterType = useMonitoringSwaggerClient<void>()

    return useCallback(
        (parameterTypeCode: string) => {
            return deleteParameterType({ url: `/paramtypes/${parameterTypeCode}`, method: 'DELETE' })
        },
        [deleteParameterType],
    )
}

export const useDeleteParameterTypeMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteParameterTypeHook>>>, TError, { parameterTypeCode: string }, TContext>
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteParameterTypeHook>>>, TError, { parameterTypeCode: string }, TContext> => {
    const { mutation: mutationOptions } = options ?? {}

    const deleteParameterType = useDeleteParameterTypeHook()

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteParameterTypeHook>>>, { parameterTypeCode: string }> = (
        props,
    ) => {
        const { parameterTypeCode } = props ?? {}

        return deleteParameterType(parameterTypeCode)
    }

    return { mutationFn, ...mutationOptions }
}

export type DeleteParameterTypeMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteParameterTypeHook>>>>

export type DeleteParameterTypeMutationError = ApiError

export const useDeleteParameterType = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteParameterTypeHook>>>, TError, { parameterTypeCode: string }, TContext>
}): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useDeleteParameterTypeHook>>>, TError, { parameterTypeCode: string }, TContext> => {
    const mutationOptions = useDeleteParameterTypeMutationOptions(options)

    return useMutation(mutationOptions)
}

export const useAddMonitoredValueHook = () => {
    const addMonitoredValue = useMonitoringSwaggerClient<MonitoredValueListDto>()

    return useCallback(
        (addMonitoredValueRequest: AddMonitoredValueRequest) => {
            return addMonitoredValue({
                url: `/param-value/values`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: addMonitoredValueRequest,
            })
        },
        [addMonitoredValue],
    )
}

export const useAddMonitoredValueMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useAddMonitoredValueHook>>>,
        TError,
        { data: AddMonitoredValueRequest },
        TContext
    >
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAddMonitoredValueHook>>>, TError, { data: AddMonitoredValueRequest }, TContext> => {
    const { mutation: mutationOptions } = options ?? {}

    const addMonitoredValue = useAddMonitoredValueHook()

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useAddMonitoredValueHook>>>, { data: AddMonitoredValueRequest }> = (
        props,
    ) => {
        const { data } = props ?? {}

        return addMonitoredValue(data)
    }

    return { mutationFn, ...mutationOptions }
}

export type AddMonitoredValueMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAddMonitoredValueHook>>>>
export type AddMonitoredValueMutationBody = AddMonitoredValueRequest
export type AddMonitoredValueMutationError = ApiError

export const useAddMonitoredValue = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useAddMonitoredValueHook>>>,
        TError,
        { data: AddMonitoredValueRequest },
        TContext
    >
}): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useAddMonitoredValueHook>>>, TError, { data: AddMonitoredValueRequest }, TContext> => {
    const mutationOptions = useAddMonitoredValueMutationOptions(options)

    return useMutation(mutationOptions)
}

export const useUpdateHook = () => {
    const update = useMonitoringSwaggerClient<ApiActiveMonitoringCfg>()

    return useCallback(
        (apiActiveMonitoringCfg: ApiActiveMonitoringCfg) => {
            return update({
                url: `/activeMonitoring/cfg/update`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: apiActiveMonitoringCfg,
            })
        },
        [update],
    )
}

export const useUpdateMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateHook>>>, TError, { data: ApiActiveMonitoringCfg }, TContext>
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateHook>>>, TError, { data: ApiActiveMonitoringCfg }, TContext> => {
    const { mutation: mutationOptions } = options ?? {}

    const update = useUpdateHook()

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateHook>>>, { data: ApiActiveMonitoringCfg }> = (props) => {
        const { data } = props ?? {}

        return update(data)
    }

    return { mutationFn, ...mutationOptions }
}

export type UpdateMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateHook>>>>
export type UpdateMutationBody = ApiActiveMonitoringCfg
export type UpdateMutationError = ApiError

export const useUpdate = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateHook>>>, TError, { data: ApiActiveMonitoringCfg }, TContext>
}): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useUpdateHook>>>, TError, { data: ApiActiveMonitoringCfg }, TContext> => {
    const mutationOptions = useUpdateMutationOptions(options)

    return useMutation(mutationOptions)
}

export const useMigrateMonitoringValuesHook = () => {
    const migrateMonitoringValues = useMonitoringSwaggerClient<string>()

    return useCallback(() => {
        return migrateMonitoringValues({ url: `/utils/migrate-monitoring-values`, method: 'POST' })
    }, [migrateMonitoringValues])
}

export const useMigrateMonitoringValuesMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useMigrateMonitoringValuesHook>>>, TError, void, TContext>
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useMigrateMonitoringValuesHook>>>, TError, void, TContext> => {
    const { mutation: mutationOptions } = options ?? {}

    const migrateMonitoringValues = useMigrateMonitoringValuesHook()

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useMigrateMonitoringValuesHook>>>, void> = () => {
        return migrateMonitoringValues()
    }

    return { mutationFn, ...mutationOptions }
}

export type MigrateMonitoringValuesMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useMigrateMonitoringValuesHook>>>>

export type MigrateMonitoringValuesMutationError = ApiError

export const useMigrateMonitoringValues = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useMigrateMonitoringValuesHook>>>, TError, void, TContext>
}): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useMigrateMonitoringValuesHook>>>, TError, void, TContext> => {
    const mutationOptions = useMigrateMonitoringValuesMutationOptions(options)

    return useMutation(mutationOptions)
}

export const useSaveSlaParameterHook = () => {
    const saveSlaParameter = useMonitoringSwaggerClient<void>()

    return useCallback(
        (apiSlaParameterWriteExtended: ApiSlaParameterWriteExtended) => {
            return saveSlaParameter({
                url: `/slaparams/saveslaparam`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: apiSlaParameterWriteExtended,
            })
        },
        [saveSlaParameter],
    )
}

export const useSaveSlaParameterMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useSaveSlaParameterHook>>>,
        TError,
        { data: ApiSlaParameterWriteExtended },
        TContext
    >
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useSaveSlaParameterHook>>>, TError, { data: ApiSlaParameterWriteExtended }, TContext> => {
    const { mutation: mutationOptions } = options ?? {}

    const saveSlaParameter = useSaveSlaParameterHook()

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useSaveSlaParameterHook>>>, { data: ApiSlaParameterWriteExtended }> = (
        props,
    ) => {
        const { data } = props ?? {}

        return saveSlaParameter(data)
    }

    return { mutationFn, ...mutationOptions }
}

export type SaveSlaParameterMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useSaveSlaParameterHook>>>>
export type SaveSlaParameterMutationBody = ApiSlaParameterWriteExtended
export type SaveSlaParameterMutationError = ApiError

export const useSaveSlaParameter = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useSaveSlaParameterHook>>>,
        TError,
        { data: ApiSlaParameterWriteExtended },
        TContext
    >
}): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useSaveSlaParameterHook>>>, TError, { data: ApiSlaParameterWriteExtended }, TContext> => {
    const mutationOptions = useSaveSlaParameterMutationOptions(options)

    return useMutation(mutationOptions)
}

/**
 * @summary checkSlaParameter
 */
export const useCheckSlaParameterHook = () => {
    const checkSlaParameter = useMonitoringSwaggerClient<ServiceDataHolder[]>()

    return useCallback(
        (apiSlaParameterWrite: ApiSlaParameterWrite) => {
            return checkSlaParameter({
                url: `/slaparams/checkslaparam`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: apiSlaParameterWrite,
            })
        },
        [checkSlaParameter],
    )
}

export const useCheckSlaParameterMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCheckSlaParameterHook>>>, TError, { data: ApiSlaParameterWrite }, TContext>
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCheckSlaParameterHook>>>, TError, { data: ApiSlaParameterWrite }, TContext> => {
    const { mutation: mutationOptions } = options ?? {}

    const checkSlaParameter = useCheckSlaParameterHook()

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCheckSlaParameterHook>>>, { data: ApiSlaParameterWrite }> = (
        props,
    ) => {
        const { data } = props ?? {}

        return checkSlaParameter(data)
    }

    return { mutationFn, ...mutationOptions }
}

export type CheckSlaParameterMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCheckSlaParameterHook>>>>
export type CheckSlaParameterMutationBody = ApiSlaParameterWrite
export type CheckSlaParameterMutationError = ApiError

/**
 * @summary checkSlaParameter
 */
export const useCheckSlaParameter = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCheckSlaParameterHook>>>, TError, { data: ApiSlaParameterWrite }, TContext>
}): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useCheckSlaParameterHook>>>, TError, { data: ApiSlaParameterWrite }, TContext> => {
    const mutationOptions = useCheckSlaParameterMutationOptions(options)

    return useMutation(mutationOptions)
}

export const useSlaContractTransitionHook = () => {
    const slaContractTransition = useMonitoringSwaggerClient<void>()

    return useCallback(
        (slaContractUuid: string, transition: string) => {
            return slaContractTransition({ url: `/slacontract/${slaContractUuid}/transitions/${transition}`, method: 'POST' })
        },
        [slaContractTransition],
    )
}

export const useSlaContractTransitionMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useSlaContractTransitionHook>>>,
        TError,
        { slaContractUuid: string; transition: string },
        TContext
    >
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useSlaContractTransitionHook>>>,
    TError,
    { slaContractUuid: string; transition: string },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {}

    const slaContractTransition = useSlaContractTransitionHook()

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useSlaContractTransitionHook>>>,
        { slaContractUuid: string; transition: string }
    > = (props) => {
        const { slaContractUuid, transition } = props ?? {}

        return slaContractTransition(slaContractUuid, transition)
    }

    return { mutationFn, ...mutationOptions }
}

export type SlaContractTransitionMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useSlaContractTransitionHook>>>>

export type SlaContractTransitionMutationError = ApiError

export const useSlaContractTransition = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useSlaContractTransitionHook>>>,
        TError,
        { slaContractUuid: string; transition: string },
        TContext
    >
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useSlaContractTransitionHook>>>,
    TError,
    { slaContractUuid: string; transition: string },
    TContext
> => {
    const mutationOptions = useSlaContractTransitionMutationOptions(options)

    return useMutation(mutationOptions)
}

export const useSaveSlaContractHook = () => {
    const saveSlaContract = useMonitoringSwaggerClient<void>()

    return useCallback(
        (apiSlaContractWrite: ApiSlaContractWrite) => {
            return saveSlaContract({
                url: `/slacontract/save`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: apiSlaContractWrite,
            })
        },
        [saveSlaContract],
    )
}

export const useSaveSlaContractMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useSaveSlaContractHook>>>, TError, { data: ApiSlaContractWrite }, TContext>
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useSaveSlaContractHook>>>, TError, { data: ApiSlaContractWrite }, TContext> => {
    const { mutation: mutationOptions } = options ?? {}

    const saveSlaContract = useSaveSlaContractHook()

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useSaveSlaContractHook>>>, { data: ApiSlaContractWrite }> = (props) => {
        const { data } = props ?? {}

        return saveSlaContract(data)
    }

    return { mutationFn, ...mutationOptions }
}

export type SaveSlaContractMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useSaveSlaContractHook>>>>
export type SaveSlaContractMutationBody = ApiSlaContractWrite
export type SaveSlaContractMutationError = ApiError

export const useSaveSlaContract = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useSaveSlaContractHook>>>, TError, { data: ApiSlaContractWrite }, TContext>
}): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useSaveSlaContractHook>>>, TError, { data: ApiSlaContractWrite }, TContext> => {
    const mutationOptions = useSaveSlaContractMutationOptions(options)

    return useMutation(mutationOptions)
}

export const useListParameterTypes1Hook = () => {
    const listParameterTypes1 = useMonitoringSwaggerClient<ApiParameterTypesList>()

    return useCallback(
        (params?: ListParameterTypes1Params, signal?: AbortSignal) => {
            return listParameterTypes1({ url: `/paramtypes`, method: 'GET', params, signal })
        },
        [listParameterTypes1],
    )
}

export const getListParameterTypes1QueryKey = (params?: ListParameterTypes1Params) => {
    return [`/paramtypes`, ...(params ? [params] : [])] as const
}

export const useListParameterTypes1QueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useListParameterTypes1Hook>>>, TError = ApiError>(
    params?: ListParameterTypes1Params,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListParameterTypes1Hook>>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getListParameterTypes1QueryKey(params)

    const listParameterTypes1 = useListParameterTypes1Hook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListParameterTypes1Hook>>>> = ({ signal }) =>
        listParameterTypes1(params, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListParameterTypes1Hook>>>,
        TError,
        TData
    > & { queryKey: QueryKey }
}

export type ListParameterTypes1QueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListParameterTypes1Hook>>>>
export type ListParameterTypes1QueryError = ApiError

export function useListParameterTypes1<TData = Awaited<ReturnType<ReturnType<typeof useListParameterTypes1Hook>>>, TError = ApiError>(
    params?: ListParameterTypes1Params,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListParameterTypes1Hook>>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useListParameterTypes1QueryOptions(params, options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useAddParameterTypeHook = () => {
    const addParameterType = useMonitoringSwaggerClient<void>()

    return useCallback(
        (apiParameterType: ApiParameterType) => {
            return addParameterType({ url: `/paramtypes`, method: 'POST', headers: { 'Content-Type': 'application/json' }, data: apiParameterType })
        },
        [addParameterType],
    )
}

export const useAddParameterTypeMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAddParameterTypeHook>>>, TError, { data: ApiParameterType }, TContext>
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAddParameterTypeHook>>>, TError, { data: ApiParameterType }, TContext> => {
    const { mutation: mutationOptions } = options ?? {}

    const addParameterType = useAddParameterTypeHook()

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useAddParameterTypeHook>>>, { data: ApiParameterType }> = (props) => {
        const { data } = props ?? {}

        return addParameterType(data)
    }

    return { mutationFn, ...mutationOptions }
}

export type AddParameterTypeMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAddParameterTypeHook>>>>
export type AddParameterTypeMutationBody = ApiParameterType
export type AddParameterTypeMutationError = ApiError

export const useAddParameterType = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAddParameterTypeHook>>>, TError, { data: ApiParameterType }, TContext>
}): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useAddParameterTypeHook>>>, TError, { data: ApiParameterType }, TContext> => {
    const mutationOptions = useAddParameterTypeMutationOptions(options)

    return useMutation(mutationOptions)
}

export const useAddRelatedParameterTypeHook = () => {
    const addRelatedParameterType = useMonitoringSwaggerClient<void>()

    return useCallback(
        (parameterTypeCode: string, relatedParameterTypeType: 'SLA' | 'MONITORING', relatedParameterTypeCode: string) => {
            return addRelatedParameterType({
                url: `/paramtypes/${parameterTypeCode}/related/${relatedParameterTypeType}/${relatedParameterTypeCode}`,
                method: 'POST',
            })
        },
        [addRelatedParameterType],
    )
}

export const useAddRelatedParameterTypeMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useAddRelatedParameterTypeHook>>>,
        TError,
        { parameterTypeCode: string; relatedParameterTypeType: 'SLA' | 'MONITORING'; relatedParameterTypeCode: string },
        TContext
    >
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAddRelatedParameterTypeHook>>>,
    TError,
    { parameterTypeCode: string; relatedParameterTypeType: 'SLA' | 'MONITORING'; relatedParameterTypeCode: string },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {}

    const addRelatedParameterType = useAddRelatedParameterTypeHook()

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useAddRelatedParameterTypeHook>>>,
        { parameterTypeCode: string; relatedParameterTypeType: 'SLA' | 'MONITORING'; relatedParameterTypeCode: string }
    > = (props) => {
        const { parameterTypeCode, relatedParameterTypeType, relatedParameterTypeCode } = props ?? {}

        return addRelatedParameterType(parameterTypeCode, relatedParameterTypeType, relatedParameterTypeCode)
    }

    return { mutationFn, ...mutationOptions }
}

export type AddRelatedParameterTypeMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAddRelatedParameterTypeHook>>>>

export type AddRelatedParameterTypeMutationError = ApiError

export const useAddRelatedParameterType = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useAddRelatedParameterTypeHook>>>,
        TError,
        { parameterTypeCode: string; relatedParameterTypeType: 'SLA' | 'MONITORING'; relatedParameterTypeCode: string },
        TContext
    >
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useAddRelatedParameterTypeHook>>>,
    TError,
    { parameterTypeCode: string; relatedParameterTypeType: 'SLA' | 'MONITORING'; relatedParameterTypeCode: string },
    TContext
> => {
    const mutationOptions = useAddRelatedParameterTypeMutationOptions(options)

    return useMutation(mutationOptions)
}

export const useDeleteRelatedParameterTypeHook = () => {
    const deleteRelatedParameterType = useMonitoringSwaggerClient<void>()

    return useCallback(
        (parameterTypeCode: string, relatedParameterTypeType: 'SLA' | 'MONITORING', relatedParameterTypeCode: string) => {
            return deleteRelatedParameterType({
                url: `/paramtypes/${parameterTypeCode}/related/${relatedParameterTypeType}/${relatedParameterTypeCode}`,
                method: 'DELETE',
            })
        },
        [deleteRelatedParameterType],
    )
}

export const useDeleteRelatedParameterTypeMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeleteRelatedParameterTypeHook>>>,
        TError,
        { parameterTypeCode: string; relatedParameterTypeType: 'SLA' | 'MONITORING'; relatedParameterTypeCode: string },
        TContext
    >
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteRelatedParameterTypeHook>>>,
    TError,
    { parameterTypeCode: string; relatedParameterTypeType: 'SLA' | 'MONITORING'; relatedParameterTypeCode: string },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {}

    const deleteRelatedParameterType = useDeleteRelatedParameterTypeHook()

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeleteRelatedParameterTypeHook>>>,
        { parameterTypeCode: string; relatedParameterTypeType: 'SLA' | 'MONITORING'; relatedParameterTypeCode: string }
    > = (props) => {
        const { parameterTypeCode, relatedParameterTypeType, relatedParameterTypeCode } = props ?? {}

        return deleteRelatedParameterType(parameterTypeCode, relatedParameterTypeType, relatedParameterTypeCode)
    }

    return { mutationFn, ...mutationOptions }
}

export type DeleteRelatedParameterTypeMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteRelatedParameterTypeHook>>>>

export type DeleteRelatedParameterTypeMutationError = ApiError

export const useDeleteRelatedParameterType = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeleteRelatedParameterTypeHook>>>,
        TError,
        { parameterTypeCode: string; relatedParameterTypeType: 'SLA' | 'MONITORING'; relatedParameterTypeCode: string },
        TContext
    >
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useDeleteRelatedParameterTypeHook>>>,
    TError,
    { parameterTypeCode: string; relatedParameterTypeType: 'SLA' | 'MONITORING'; relatedParameterTypeCode: string },
    TContext
> => {
    const mutationOptions = useDeleteRelatedParameterTypeMutationOptions(options)

    return useMutation(mutationOptions)
}

export const useEditMonitoredValueHook = () => {
    const editMonitoredValue = useMonitoringSwaggerClient<MonitoredValueDto>()

    return useCallback(
        (id: number, newMonitoredValueDto: NewMonitoredValueDto) => {
            return editMonitoredValue({
                url: `/param-value/values/${id}`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: newMonitoredValueDto,
            })
        },
        [editMonitoredValue],
    )
}

export const useEditMonitoredValueMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useEditMonitoredValueHook>>>,
        TError,
        { id: number; data: NewMonitoredValueDto },
        TContext
    >
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useEditMonitoredValueHook>>>,
    TError,
    { id: number; data: NewMonitoredValueDto },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {}

    const editMonitoredValue = useEditMonitoredValueHook()

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useEditMonitoredValueHook>>>,
        { id: number; data: NewMonitoredValueDto }
    > = (props) => {
        const { id, data } = props ?? {}

        return editMonitoredValue(id, data)
    }

    return { mutationFn, ...mutationOptions }
}

export type EditMonitoredValueMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useEditMonitoredValueHook>>>>
export type EditMonitoredValueMutationBody = NewMonitoredValueDto
export type EditMonitoredValueMutationError = ApiError

export const useEditMonitoredValue = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useEditMonitoredValueHook>>>,
        TError,
        { id: number; data: NewMonitoredValueDto },
        TContext
    >
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useEditMonitoredValueHook>>>,
    TError,
    { id: number; data: NewMonitoredValueDto },
    TContext
> => {
    const mutationOptions = useEditMonitoredValueMutationOptions(options)

    return useMutation(mutationOptions)
}

export const useDeleteMonitoredValueHook = () => {
    const deleteMonitoredValue = useMonitoringSwaggerClient<void>()

    return useCallback(
        (id: number) => {
            return deleteMonitoredValue({ url: `/param-value/values/${id}`, method: 'DELETE' })
        },
        [deleteMonitoredValue],
    )
}

export const useDeleteMonitoredValueMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteMonitoredValueHook>>>, TError, { id: number }, TContext>
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteMonitoredValueHook>>>, TError, { id: number }, TContext> => {
    const { mutation: mutationOptions } = options ?? {}

    const deleteMonitoredValue = useDeleteMonitoredValueHook()

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteMonitoredValueHook>>>, { id: number }> = (props) => {
        const { id } = props ?? {}

        return deleteMonitoredValue(id)
    }

    return { mutationFn, ...mutationOptions }
}

export type DeleteMonitoredValueMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteMonitoredValueHook>>>>

export type DeleteMonitoredValueMutationError = ApiError

export const useDeleteMonitoredValue = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteMonitoredValueHook>>>, TError, { id: number }, TContext>
}): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useDeleteMonitoredValueHook>>>, TError, { id: number }, TContext> => {
    const mutationOptions = useDeleteMonitoredValueMutationOptions(options)

    return useMutation(mutationOptions)
}

/**
 * @summary validateReport
 */
export const useValidateReportHook = () => {
    const validateReport = useMonitoringSwaggerClient<XmlValidationResult>()

    return useCallback(
        (validateReportBody: ValidateReportBody) => {
            return validateReport({
                url: `/param-value/validateReport`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: validateReportBody,
            })
        },
        [validateReport],
    )
}

export const useValidateReportMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useValidateReportHook>>>, TError, { data: ValidateReportBody }, TContext>
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useValidateReportHook>>>, TError, { data: ValidateReportBody }, TContext> => {
    const { mutation: mutationOptions } = options ?? {}

    const validateReport = useValidateReportHook()

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useValidateReportHook>>>, { data: ValidateReportBody }> = (props) => {
        const { data } = props ?? {}

        return validateReport(data)
    }

    return { mutationFn, ...mutationOptions }
}

export type ValidateReportMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useValidateReportHook>>>>
export type ValidateReportMutationBody = ValidateReportBody
export type ValidateReportMutationError = ApiError

/**
 * @summary validateReport
 */
export const useValidateReport = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useValidateReportHook>>>, TError, { data: ValidateReportBody }, TContext>
}): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useValidateReportHook>>>, TError, { data: ValidateReportBody }, TContext> => {
    const mutationOptions = useValidateReportMutationOptions(options)

    return useMutation(mutationOptions)
}

export const useValidateMonitorParametersHook = () => {
    const validateMonitorParameters = useMonitoringSwaggerClient<ImportMonitoringResult>()

    return useCallback(
        (validateMonitorParametersBody: ValidateMonitorParametersBody) => {
            return validateMonitorParameters({
                url: `/param-value/v2/validateReport`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: validateMonitorParametersBody,
            })
        },
        [validateMonitorParameters],
    )
}

export const useValidateMonitorParametersMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useValidateMonitorParametersHook>>>,
        TError,
        { data: ValidateMonitorParametersBody },
        TContext
    >
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useValidateMonitorParametersHook>>>,
    TError,
    { data: ValidateMonitorParametersBody },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {}

    const validateMonitorParameters = useValidateMonitorParametersHook()

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useValidateMonitorParametersHook>>>,
        { data: ValidateMonitorParametersBody }
    > = (props) => {
        const { data } = props ?? {}

        return validateMonitorParameters(data)
    }

    return { mutationFn, ...mutationOptions }
}

export type ValidateMonitorParametersMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useValidateMonitorParametersHook>>>>
export type ValidateMonitorParametersMutationBody = ValidateMonitorParametersBody
export type ValidateMonitorParametersMutationError = ApiError

export const useValidateMonitorParameters = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useValidateMonitorParametersHook>>>,
        TError,
        { data: ValidateMonitorParametersBody },
        TContext
    >
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useValidateMonitorParametersHook>>>,
    TError,
    { data: ValidateMonitorParametersBody },
    TContext
> => {
    const mutationOptions = useValidateMonitorParametersMutationOptions(options)

    return useMutation(mutationOptions)
}

export const useImportMonitorParametersHook = () => {
    const importMonitorParameters = useMonitoringSwaggerClient<ImportMonitoringResult>()

    return useCallback(
        (importMonitorParametersBody: ImportMonitorParametersBody) => {
            return importMonitorParameters({
                url: `/param-value/v2/importReport`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: importMonitorParametersBody,
            })
        },
        [importMonitorParameters],
    )
}

export const useImportMonitorParametersMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useImportMonitorParametersHook>>>,
        TError,
        { data: ImportMonitorParametersBody },
        TContext
    >
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useImportMonitorParametersHook>>>,
    TError,
    { data: ImportMonitorParametersBody },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {}

    const importMonitorParameters = useImportMonitorParametersHook()

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useImportMonitorParametersHook>>>,
        { data: ImportMonitorParametersBody }
    > = (props) => {
        const { data } = props ?? {}

        return importMonitorParameters(data)
    }

    return { mutationFn, ...mutationOptions }
}

export type ImportMonitorParametersMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useImportMonitorParametersHook>>>>
export type ImportMonitorParametersMutationBody = ImportMonitorParametersBody
export type ImportMonitorParametersMutationError = ApiError

export const useImportMonitorParameters = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useImportMonitorParametersHook>>>,
        TError,
        { data: ImportMonitorParametersBody },
        TContext
    >
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useImportMonitorParametersHook>>>,
    TError,
    { data: ImportMonitorParametersBody },
    TContext
> => {
    const mutationOptions = useImportMonitorParametersMutationOptions(options)

    return useMutation(mutationOptions)
}

/**
 * @summary listMultipleServiceParameterExportValues
 */
export const useListMultipleServiceParameterExportValuesHook = () => {
    const listMultipleServiceParameterExportValues = useMonitoringSwaggerClient<MonitoredExportList>()

    return useCallback(
        (monitoredExportRequest: MonitoredExportRequest) => {
            return listMultipleServiceParameterExportValues({
                url: `/param-value/list-multiple-export`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: monitoredExportRequest,
            })
        },
        [listMultipleServiceParameterExportValues],
    )
}

export const useListMultipleServiceParameterExportValuesMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useListMultipleServiceParameterExportValuesHook>>>,
        TError,
        { data: MonitoredExportRequest },
        TContext
    >
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useListMultipleServiceParameterExportValuesHook>>>,
    TError,
    { data: MonitoredExportRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {}

    const listMultipleServiceParameterExportValues = useListMultipleServiceParameterExportValuesHook()

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useListMultipleServiceParameterExportValuesHook>>>,
        { data: MonitoredExportRequest }
    > = (props) => {
        const { data } = props ?? {}

        return listMultipleServiceParameterExportValues(data)
    }

    return { mutationFn, ...mutationOptions }
}

export type ListMultipleServiceParameterExportValuesMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useListMultipleServiceParameterExportValuesHook>>>
>
export type ListMultipleServiceParameterExportValuesMutationBody = MonitoredExportRequest
export type ListMultipleServiceParameterExportValuesMutationError = ApiError

/**
 * @summary listMultipleServiceParameterExportValues
 */
export const useListMultipleServiceParameterExportValues = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useListMultipleServiceParameterExportValuesHook>>>,
        TError,
        { data: MonitoredExportRequest },
        TContext
    >
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useListMultipleServiceParameterExportValuesHook>>>,
    TError,
    { data: MonitoredExportRequest },
    TContext
> => {
    const mutationOptions = useListMultipleServiceParameterExportValuesMutationOptions(options)

    return useMutation(mutationOptions)
}

export const useListMonitoredValuesHook = () => {
    const listMonitoredValues = useMonitoringSwaggerClient<MonitoredValueListDto>()

    return useCallback(
        (monitoredEntityId: number, listMonitoredValuesRequest: ListMonitoredValuesRequest) => {
            return listMonitoredValues({
                url: `/param-value/items/${monitoredEntityId}/values`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: listMonitoredValuesRequest,
            })
        },
        [listMonitoredValues],
    )
}

export const useListMonitoredValuesMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useListMonitoredValuesHook>>>,
        TError,
        { monitoredEntityId: number; data: ListMonitoredValuesRequest },
        TContext
    >
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useListMonitoredValuesHook>>>,
    TError,
    { monitoredEntityId: number; data: ListMonitoredValuesRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {}

    const listMonitoredValues = useListMonitoredValuesHook()

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useListMonitoredValuesHook>>>,
        { monitoredEntityId: number; data: ListMonitoredValuesRequest }
    > = (props) => {
        const { monitoredEntityId, data } = props ?? {}

        return listMonitoredValues(monitoredEntityId, data)
    }

    return { mutationFn, ...mutationOptions }
}

export type ListMonitoredValuesMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListMonitoredValuesHook>>>>
export type ListMonitoredValuesMutationBody = ListMonitoredValuesRequest
export type ListMonitoredValuesMutationError = ApiError

export const useListMonitoredValues = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useListMonitoredValuesHook>>>,
        TError,
        { monitoredEntityId: number; data: ListMonitoredValuesRequest },
        TContext
    >
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useListMonitoredValuesHook>>>,
    TError,
    { monitoredEntityId: number; data: ListMonitoredValuesRequest },
    TContext
> => {
    const mutationOptions = useListMonitoredValuesMutationOptions(options)

    return useMutation(mutationOptions)
}

/**
 * @summary listMultipleServiceParameterValues
 */
export const useListMultipleServiceParameterValuesHook = () => {
    const listMultipleServiceParameterValues = useMonitoringSwaggerClient<MonitoredValueListDto>()

    return useCallback(
        (listMultipleServiceParameterValuesRequest: ListMultipleServiceParameterValuesRequest) => {
            return listMultipleServiceParameterValues({
                url: `/param-value/items/values`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: listMultipleServiceParameterValuesRequest,
            })
        },
        [listMultipleServiceParameterValues],
    )
}

export const useListMultipleServiceParameterValuesMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useListMultipleServiceParameterValuesHook>>>,
        TError,
        { data: ListMultipleServiceParameterValuesRequest },
        TContext
    >
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useListMultipleServiceParameterValuesHook>>>,
    TError,
    { data: ListMultipleServiceParameterValuesRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {}

    const listMultipleServiceParameterValues = useListMultipleServiceParameterValuesHook()

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useListMultipleServiceParameterValuesHook>>>,
        { data: ListMultipleServiceParameterValuesRequest }
    > = (props) => {
        const { data } = props ?? {}

        return listMultipleServiceParameterValues(data)
    }

    return { mutationFn, ...mutationOptions }
}

export type ListMultipleServiceParameterValuesMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useListMultipleServiceParameterValuesHook>>>
>
export type ListMultipleServiceParameterValuesMutationBody = ListMultipleServiceParameterValuesRequest
export type ListMultipleServiceParameterValuesMutationError = ApiError

/**
 * @summary listMultipleServiceParameterValues
 */
export const useListMultipleServiceParameterValues = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useListMultipleServiceParameterValuesHook>>>,
        TError,
        { data: ListMultipleServiceParameterValuesRequest },
        TContext
    >
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useListMultipleServiceParameterValuesHook>>>,
    TError,
    { data: ListMultipleServiceParameterValuesRequest },
    TContext
> => {
    const mutationOptions = useListMultipleServiceParameterValuesMutationOptions(options)

    return useMutation(mutationOptions)
}

export const useListMonitoredItemsHook = () => {
    const listMonitoredItems = useMonitoringSwaggerClient<MonitoredItemListDto>()

    return useCallback(
        (listMonitoringOverviewRequest: ListMonitoringOverviewRequest) => {
            return listMonitoredItems({
                url: `/param-value/items/list`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: listMonitoringOverviewRequest,
            })
        },
        [listMonitoredItems],
    )
}

export const getListMonitoredItemsQueryKey = (listMonitoringOverviewRequest: ListMonitoringOverviewRequest) => {
    return [`/param-value/items/list`, listMonitoringOverviewRequest] as const
}

export const useListMonitoredItemsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useListMonitoredItemsHook>>>, TError = ApiError>(
    listMonitoringOverviewRequest: ListMonitoringOverviewRequest,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListMonitoredItemsHook>>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getListMonitoredItemsQueryKey(listMonitoringOverviewRequest)

    const listMonitoredItems = useListMonitoredItemsHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListMonitoredItemsHook>>>> = ({ signal }) =>
        listMonitoredItems(listMonitoringOverviewRequest, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListMonitoredItemsHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey }
}

export type ListMonitoredItemsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListMonitoredItemsHook>>>>
export type ListMonitoredItemsQueryError = ApiError

export function useListMonitoredItems<TData = Awaited<ReturnType<ReturnType<typeof useListMonitoredItemsHook>>>, TError = ApiError>(
    listMonitoringOverviewRequest: ListMonitoringOverviewRequest,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListMonitoredItemsHook>>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useListMonitoredItemsQueryOptions(listMonitoringOverviewRequest, options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useListMonitoredIsvsHook = () => {
    const listMonitoredIsvs = useMonitoringSwaggerClient<ListMonitoredIsvsResponse>()

    return useCallback(
        (listMonitoredIsvsRequest: ListMonitoredIsvsRequest) => {
            return listMonitoredIsvs({
                url: `/param-value/isvs/list`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: listMonitoredIsvsRequest,
            })
        },
        [listMonitoredIsvs],
    )
}

export const getListMonitoredIsvsQueryKey = (listMonitoredIsvsRequest: ListMonitoredIsvsRequest) => {
    return [`/param-value/isvs/list`, listMonitoredIsvsRequest] as const
}

export const useListMonitoredIsvsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useListMonitoredIsvsHook>>>, TError = ApiError>(
    listMonitoredIsvsRequest: ListMonitoredIsvsRequest,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListMonitoredIsvsHook>>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getListMonitoredIsvsQueryKey(listMonitoredIsvsRequest)

    const listMonitoredIsvs = useListMonitoredIsvsHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListMonitoredIsvsHook>>>> = ({ signal }) =>
        listMonitoredIsvs(listMonitoredIsvsRequest, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListMonitoredIsvsHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey }
}

export type ListMonitoredIsvsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListMonitoredIsvsHook>>>>
export type ListMonitoredIsvsQueryError = ApiError

export function useListMonitoredIsvs<TData = Awaited<ReturnType<ReturnType<typeof useListMonitoredIsvsHook>>>, TError = ApiError>(
    listMonitoredIsvsRequest: ListMonitoredIsvsRequest,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListMonitoredIsvsHook>>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useListMonitoredIsvsQueryOptions(listMonitoredIsvsRequest, options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useImportReportHook = () => {
    const importReport = useMonitoringSwaggerClient<XmlImportResult>()

    return useCallback(
        (importReportBody: ImportReportBody) => {
            return importReport({
                url: `/param-value/importReport`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: importReportBody,
            })
        },
        [importReport],
    )
}

export const useImportReportMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useImportReportHook>>>, TError, { data: ImportReportBody }, TContext>
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useImportReportHook>>>, TError, { data: ImportReportBody }, TContext> => {
    const { mutation: mutationOptions } = options ?? {}

    const importReport = useImportReportHook()

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useImportReportHook>>>, { data: ImportReportBody }> = (props) => {
        const { data } = props ?? {}

        return importReport(data)
    }

    return { mutationFn, ...mutationOptions }
}

export type ImportReportMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useImportReportHook>>>>
export type ImportReportMutationBody = ImportReportBody
export type ImportReportMutationError = ApiError

export const useImportReport = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useImportReportHook>>>, TError, { data: ImportReportBody }, TContext>
}): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useImportReportHook>>>, TError, { data: ImportReportBody }, TContext> => {
    const mutationOptions = useImportReportMutationOptions(options)

    return useMutation(mutationOptions)
}

export const useImportReport2Hook = () => {
    const importReport2 = useMonitoringSwaggerClient<XmlImportResult[]>()

    return useCallback(
        (apiImportMonitoringReports: ApiImportMonitoringReports) => {
            return importReport2({
                url: `/param-value/importReport2`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: apiImportMonitoringReports,
            })
        },
        [importReport2],
    )
}

export const useImportReport2MutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useImportReport2Hook>>>,
        TError,
        { data: ApiImportMonitoringReports },
        TContext
    >
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useImportReport2Hook>>>, TError, { data: ApiImportMonitoringReports }, TContext> => {
    const { mutation: mutationOptions } = options ?? {}

    const importReport2 = useImportReport2Hook()

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useImportReport2Hook>>>, { data: ApiImportMonitoringReports }> = (
        props,
    ) => {
        const { data } = props ?? {}

        return importReport2(data)
    }

    return { mutationFn, ...mutationOptions }
}

export type ImportReport2MutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useImportReport2Hook>>>>
export type ImportReport2MutationBody = ApiImportMonitoringReports
export type ImportReport2MutationError = ApiError

export const useImportReport2 = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useImportReport2Hook>>>,
        TError,
        { data: ApiImportMonitoringReports },
        TContext
    >
}): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useImportReport2Hook>>>, TError, { data: ApiImportMonitoringReports }, TContext> => {
    const mutationOptions = useImportReport2MutationOptions(options)

    return useMutation(mutationOptions)
}

export const useOlaContractTransitionHook = () => {
    const olaContractTransition = useMonitoringSwaggerClient<RequestIdUi>()

    return useCallback(
        (olaContractUuid: string, transition: string) => {
            return olaContractTransition({ url: `/olacontract/${olaContractUuid}/transitions/${transition}`, method: 'POST' })
        },
        [olaContractTransition],
    )
}

export const useOlaContractTransitionMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useOlaContractTransitionHook>>>,
        TError,
        { olaContractUuid: string; transition: string },
        TContext
    >
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useOlaContractTransitionHook>>>,
    TError,
    { olaContractUuid: string; transition: string },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {}

    const olaContractTransition = useOlaContractTransitionHook()

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useOlaContractTransitionHook>>>,
        { olaContractUuid: string; transition: string }
    > = (props) => {
        const { olaContractUuid, transition } = props ?? {}

        return olaContractTransition(olaContractUuid, transition)
    }

    return { mutationFn, ...mutationOptions }
}

export type OlaContractTransitionMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useOlaContractTransitionHook>>>>

export type OlaContractTransitionMutationError = ApiError

export const useOlaContractTransition = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useOlaContractTransitionHook>>>,
        TError,
        { olaContractUuid: string; transition: string },
        TContext
    >
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useOlaContractTransitionHook>>>,
    TError,
    { olaContractUuid: string; transition: string },
    TContext
> => {
    const mutationOptions = useOlaContractTransitionMutationOptions(options)

    return useMutation(mutationOptions)
}

export const useUpdateOlaContractHook = () => {
    const updateOlaContract = useMonitoringSwaggerClient<RequestIdUi>()

    return useCallback(
        (apiOlaContractData: ApiOlaContractData) => {
            return updateOlaContract({
                url: `/olacontract/update`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: apiOlaContractData,
            })
        },
        [updateOlaContract],
    )
}

export const useUpdateOlaContractMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateOlaContractHook>>>, TError, { data: ApiOlaContractData }, TContext>
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateOlaContractHook>>>, TError, { data: ApiOlaContractData }, TContext> => {
    const { mutation: mutationOptions } = options ?? {}

    const updateOlaContract = useUpdateOlaContractHook()

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateOlaContractHook>>>, { data: ApiOlaContractData }> = (props) => {
        const { data } = props ?? {}

        return updateOlaContract(data)
    }

    return { mutationFn, ...mutationOptions }
}

export type UpdateOlaContractMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateOlaContractHook>>>>
export type UpdateOlaContractMutationBody = ApiOlaContractData
export type UpdateOlaContractMutationError = ApiError

export const useUpdateOlaContract = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateOlaContractHook>>>, TError, { data: ApiOlaContractData }, TContext>
}): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useUpdateOlaContractHook>>>, TError, { data: ApiOlaContractData }, TContext> => {
    const mutationOptions = useUpdateOlaContractMutationOptions(options)

    return useMutation(mutationOptions)
}

export const useSaveOlaContractHook = () => {
    const saveOlaContract = useMonitoringSwaggerClient<RequestIdUi>()

    return useCallback(
        (apiOlaContractData: ApiOlaContractData) => {
            return saveOlaContract({
                url: `/olacontract/save`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: apiOlaContractData,
            })
        },
        [saveOlaContract],
    )
}

export const useSaveOlaContractMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useSaveOlaContractHook>>>, TError, { data: ApiOlaContractData }, TContext>
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useSaveOlaContractHook>>>, TError, { data: ApiOlaContractData }, TContext> => {
    const { mutation: mutationOptions } = options ?? {}

    const saveOlaContract = useSaveOlaContractHook()

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useSaveOlaContractHook>>>, { data: ApiOlaContractData }> = (props) => {
        const { data } = props ?? {}

        return saveOlaContract(data)
    }

    return { mutationFn, ...mutationOptions }
}

export type SaveOlaContractMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useSaveOlaContractHook>>>>
export type SaveOlaContractMutationBody = ApiOlaContractData
export type SaveOlaContractMutationError = ApiError

export const useSaveOlaContract = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useSaveOlaContractHook>>>, TError, { data: ApiOlaContractData }, TContext>
}): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useSaveOlaContractHook>>>, TError, { data: ApiOlaContractData }, TContext> => {
    const mutationOptions = useSaveOlaContractMutationOptions(options)

    return useMutation(mutationOptions)
}

export const useGetCurrentSystemStateHook = () => {
    const getCurrentSystemState = useMonitoringSwaggerClient<CurrentSystemState>()

    return useCallback(
        (signal?: AbortSignal) => {
            return getCurrentSystemState({ url: `/current-system-state`, method: 'GET', signal })
        },
        [getCurrentSystemState],
    )
}

export const getGetCurrentSystemStateQueryKey = () => {
    return [`/current-system-state`] as const
}

export const useGetCurrentSystemStateQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetCurrentSystemStateHook>>>,
    TError = ApiError,
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCurrentSystemStateHook>>>, TError, TData>
}) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getGetCurrentSystemStateQueryKey()

    const getCurrentSystemState = useGetCurrentSystemStateHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetCurrentSystemStateHook>>>> = ({ signal }) => getCurrentSystemState(signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetCurrentSystemStateHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey }
}

export type GetCurrentSystemStateQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetCurrentSystemStateHook>>>>
export type GetCurrentSystemStateQueryError = ApiError

export function useGetCurrentSystemState<TData = Awaited<ReturnType<ReturnType<typeof useGetCurrentSystemStateHook>>>, TError = ApiError>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCurrentSystemStateHook>>>, TError, TData>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetCurrentSystemStateQueryOptions(options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useSetCurrentSystemStateHook = () => {
    const setCurrentSystemState = useMonitoringSwaggerClient<CurrentSystemState>()

    return useCallback(
        (currentSystemStateIn: CurrentSystemStateIn) => {
            return setCurrentSystemState({
                url: `/current-system-state`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: currentSystemStateIn,
            })
        },
        [setCurrentSystemState],
    )
}

export const useSetCurrentSystemStateMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useSetCurrentSystemStateHook>>>,
        TError,
        { data: CurrentSystemStateIn },
        TContext
    >
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useSetCurrentSystemStateHook>>>, TError, { data: CurrentSystemStateIn }, TContext> => {
    const { mutation: mutationOptions } = options ?? {}

    const setCurrentSystemState = useSetCurrentSystemStateHook()

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useSetCurrentSystemStateHook>>>, { data: CurrentSystemStateIn }> = (
        props,
    ) => {
        const { data } = props ?? {}

        return setCurrentSystemState(data)
    }

    return { mutationFn, ...mutationOptions }
}

export type SetCurrentSystemStateMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useSetCurrentSystemStateHook>>>>
export type SetCurrentSystemStateMutationBody = CurrentSystemStateIn
export type SetCurrentSystemStateMutationError = ApiError

export const useSetCurrentSystemState = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useSetCurrentSystemStateHook>>>,
        TError,
        { data: CurrentSystemStateIn },
        TContext
    >
}): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useSetCurrentSystemStateHook>>>, TError, { data: CurrentSystemStateIn }, TContext> => {
    const mutationOptions = useSetCurrentSystemStateMutationOptions(options)

    return useMutation(mutationOptions)
}

export const useClearCurrentSystemStateHook = () => {
    const clearCurrentSystemState = useMonitoringSwaggerClient<CurrentSystemState>()

    return useCallback(() => {
        return clearCurrentSystemState({ url: `/current-system-state`, method: 'DELETE' })
    }, [clearCurrentSystemState])
}

export const useClearCurrentSystemStateMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useClearCurrentSystemStateHook>>>, TError, void, TContext>
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useClearCurrentSystemStateHook>>>, TError, void, TContext> => {
    const { mutation: mutationOptions } = options ?? {}

    const clearCurrentSystemState = useClearCurrentSystemStateHook()

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useClearCurrentSystemStateHook>>>, void> = () => {
        return clearCurrentSystemState()
    }

    return { mutationFn, ...mutationOptions }
}

export type ClearCurrentSystemStateMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useClearCurrentSystemStateHook>>>>

export type ClearCurrentSystemStateMutationError = ApiError

export const useClearCurrentSystemState = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useClearCurrentSystemStateHook>>>, TError, void, TContext>
}): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useClearCurrentSystemStateHook>>>, TError, void, TContext> => {
    const mutationOptions = useClearCurrentSystemStateMutationOptions(options)

    return useMutation(mutationOptions)
}

/**
 * @summary report
 */
export const useReportHook = () => {
    const report = useMonitoringSwaggerClient<ApiActiveMonitoringReportList>()

    return useCallback(
        (activeMonitoringReportRequest: ActiveMonitoringReportRequest) => {
            return report({
                url: `/activeMonitoring/cfg/report`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: activeMonitoringReportRequest,
            })
        },
        [report],
    )
}

export const useReportMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useReportHook>>>, TError, { data: ActiveMonitoringReportRequest }, TContext>
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useReportHook>>>, TError, { data: ActiveMonitoringReportRequest }, TContext> => {
    const { mutation: mutationOptions } = options ?? {}

    const report = useReportHook()

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useReportHook>>>, { data: ActiveMonitoringReportRequest }> = (props) => {
        const { data } = props ?? {}

        return report(data)
    }

    return { mutationFn, ...mutationOptions }
}

export type ReportMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useReportHook>>>>
export type ReportMutationBody = ActiveMonitoringReportRequest
export type ReportMutationError = ApiError

/**
 * @summary report
 */
export const useReport = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useReportHook>>>, TError, { data: ActiveMonitoringReportRequest }, TContext>
}): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useReportHook>>>, TError, { data: ActiveMonitoringReportRequest }, TContext> => {
    const mutationOptions = useReportMutationOptions(options)

    return useMutation(mutationOptions)
}

export const useCreateHook = () => {
    const create = useMonitoringSwaggerClient<ApiActiveMonitoringCfg>()

    return useCallback(
        (apiActiveMonitoringCfg: ApiActiveMonitoringCfg) => {
            return create({
                url: `/activeMonitoring/cfg/create`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: apiActiveMonitoringCfg,
            })
        },
        [create],
    )
}

export const useCreateMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateHook>>>, TError, { data: ApiActiveMonitoringCfg }, TContext>
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateHook>>>, TError, { data: ApiActiveMonitoringCfg }, TContext> => {
    const { mutation: mutationOptions } = options ?? {}

    const create = useCreateHook()

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCreateHook>>>, { data: ApiActiveMonitoringCfg }> = (props) => {
        const { data } = props ?? {}

        return create(data)
    }

    return { mutationFn, ...mutationOptions }
}

export type CreateMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateHook>>>>
export type CreateMutationBody = ApiActiveMonitoringCfg
export type CreateMutationError = ApiError

export const useCreate = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateHook>>>, TError, { data: ApiActiveMonitoringCfg }, TContext>
}): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useCreateHook>>>, TError, { data: ApiActiveMonitoringCfg }, TContext> => {
    const mutationOptions = useCreateMutationOptions(options)

    return useMutation(mutationOptions)
}

export const useListAllReindexTasksHook = () => {
    const listAllReindexTasks = useMonitoringSwaggerClient<AsyncTaskDto[]>()

    return useCallback(
        (signal?: AbortSignal) => {
            return listAllReindexTasks({ url: `/utils/async-tasks`, method: 'GET', signal })
        },
        [listAllReindexTasks],
    )
}

export const getListAllReindexTasksQueryKey = () => {
    return [`/utils/async-tasks`] as const
}

export const useListAllReindexTasksQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useListAllReindexTasksHook>>>,
    TError = ApiError,
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListAllReindexTasksHook>>>, TError, TData>
}) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getListAllReindexTasksQueryKey()

    const listAllReindexTasks = useListAllReindexTasksHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListAllReindexTasksHook>>>> = ({ signal }) => listAllReindexTasks(signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListAllReindexTasksHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey }
}

export type ListAllReindexTasksQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListAllReindexTasksHook>>>>
export type ListAllReindexTasksQueryError = ApiError

export function useListAllReindexTasks<TData = Awaited<ReturnType<ReturnType<typeof useListAllReindexTasksHook>>>, TError = ApiError>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListAllReindexTasksHook>>>, TError, TData>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useListAllReindexTasksQueryOptions(options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useGetReindexTaskStateByUuidHook = () => {
    const getReindexTaskStateByUuid = useMonitoringSwaggerClient<AsyncTaskDto>()

    return useCallback(
        (uuid: string, signal?: AbortSignal) => {
            return getReindexTaskStateByUuid({ url: `/utils/async-tasks/${uuid}`, method: 'GET', signal })
        },
        [getReindexTaskStateByUuid],
    )
}

export const getGetReindexTaskStateByUuidQueryKey = (uuid: string) => {
    return [`/utils/async-tasks/${uuid}`] as const
}

export const useGetReindexTaskStateByUuidQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetReindexTaskStateByUuidHook>>>,
    TError = ApiError,
>(
    uuid: string,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReindexTaskStateByUuidHook>>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getGetReindexTaskStateByUuidQueryKey(uuid)

    const getReindexTaskStateByUuid = useGetReindexTaskStateByUuidHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetReindexTaskStateByUuidHook>>>> = ({ signal }) =>
        getReindexTaskStateByUuid(uuid, signal)

    return { queryKey, queryFn, enabled: !!uuid, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetReindexTaskStateByUuidHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey }
}

export type GetReindexTaskStateByUuidQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetReindexTaskStateByUuidHook>>>>
export type GetReindexTaskStateByUuidQueryError = ApiError

export function useGetReindexTaskStateByUuid<TData = Awaited<ReturnType<ReturnType<typeof useGetReindexTaskStateByUuidHook>>>, TError = ApiError>(
    uuid: string,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReindexTaskStateByUuidHook>>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetReindexTaskStateByUuidQueryOptions(uuid, options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useCancelReindexTaskByUuidHook = () => {
    const cancelReindexTaskByUuid = useMonitoringSwaggerClient<void>()

    return useCallback(
        (uuid: string) => {
            return cancelReindexTaskByUuid({ url: `/utils/async-tasks/${uuid}`, method: 'DELETE' })
        },
        [cancelReindexTaskByUuid],
    )
}

export const useCancelReindexTaskByUuidMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCancelReindexTaskByUuidHook>>>, TError, { uuid: string }, TContext>
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCancelReindexTaskByUuidHook>>>, TError, { uuid: string }, TContext> => {
    const { mutation: mutationOptions } = options ?? {}

    const cancelReindexTaskByUuid = useCancelReindexTaskByUuidHook()

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCancelReindexTaskByUuidHook>>>, { uuid: string }> = (props) => {
        const { uuid } = props ?? {}

        return cancelReindexTaskByUuid(uuid)
    }

    return { mutationFn, ...mutationOptions }
}

export type CancelReindexTaskByUuidMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCancelReindexTaskByUuidHook>>>>

export type CancelReindexTaskByUuidMutationError = ApiError

export const useCancelReindexTaskByUuid = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCancelReindexTaskByUuidHook>>>, TError, { uuid: string }, TContext>
}): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useCancelReindexTaskByUuidHook>>>, TError, { uuid: string }, TContext> => {
    const mutationOptions = useCancelReindexTaskByUuidMutationOptions(options)

    return useMutation(mutationOptions)
}

export const useGetCurrentDateHook = () => {
    const getCurrentDate = useMonitoringSwaggerClient<GetCurrentDate200>()

    return useCallback(
        (signal?: AbortSignal) => {
            return getCurrentDate({ url: `/test/getCurrentDate`, method: 'GET', signal })
        },
        [getCurrentDate],
    )
}

export const getGetCurrentDateQueryKey = () => {
    return [`/test/getCurrentDate`] as const
}

export const useGetCurrentDateQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetCurrentDateHook>>>, TError = ApiError>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCurrentDateHook>>>, TError, TData>
}) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getGetCurrentDateQueryKey()

    const getCurrentDate = useGetCurrentDateHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetCurrentDateHook>>>> = ({ signal }) => getCurrentDate(signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCurrentDateHook>>>, TError, TData> & {
        queryKey: QueryKey
    }
}

export type GetCurrentDateQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetCurrentDateHook>>>>
export type GetCurrentDateQueryError = ApiError

export function useGetCurrentDate<TData = Awaited<ReturnType<ReturnType<typeof useGetCurrentDateHook>>>, TError = ApiError>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCurrentDateHook>>>, TError, TData>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetCurrentDateQueryOptions(options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useGetAnyStringHook = () => {
    const getAnyString = useMonitoringSwaggerClient<GetAnyString200>()

    return useCallback(
        (signal?: AbortSignal) => {
            return getAnyString({ url: `/test/getAnyString`, method: 'GET', signal })
        },
        [getAnyString],
    )
}

export const getGetAnyStringQueryKey = () => {
    return [`/test/getAnyString`] as const
}

export const useGetAnyStringQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetAnyStringHook>>>, TError = ApiError>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAnyStringHook>>>, TError, TData>
}) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getGetAnyStringQueryKey()

    const getAnyString = useGetAnyStringHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetAnyStringHook>>>> = ({ signal }) => getAnyString(signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAnyStringHook>>>, TError, TData> & {
        queryKey: QueryKey
    }
}

export type GetAnyStringQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetAnyStringHook>>>>
export type GetAnyStringQueryError = ApiError

export function useGetAnyString<TData = Awaited<ReturnType<ReturnType<typeof useGetAnyStringHook>>>, TError = ApiError>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAnyStringHook>>>, TError, TData>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetAnyStringQueryOptions(options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useGetAnyObjectHook = () => {
    const getAnyObject = useMonitoringSwaggerClient<GetAnyObject200>()

    return useCallback(
        (signal?: AbortSignal) => {
            return getAnyObject({ url: `/test/getAnyObject`, method: 'GET', signal })
        },
        [getAnyObject],
    )
}

export const getGetAnyObjectQueryKey = () => {
    return [`/test/getAnyObject`] as const
}

export const useGetAnyObjectQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetAnyObjectHook>>>, TError = ApiError>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAnyObjectHook>>>, TError, TData>
}) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getGetAnyObjectQueryKey()

    const getAnyObject = useGetAnyObjectHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetAnyObjectHook>>>> = ({ signal }) => getAnyObject(signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAnyObjectHook>>>, TError, TData> & {
        queryKey: QueryKey
    }
}

export type GetAnyObjectQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetAnyObjectHook>>>>
export type GetAnyObjectQueryError = ApiError

export function useGetAnyObject<TData = Awaited<ReturnType<ReturnType<typeof useGetAnyObjectHook>>>, TError = ApiError>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAnyObjectHook>>>, TError, TData>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetAnyObjectQueryOptions(options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useGetAnyListHook = () => {
    const getAnyList = useMonitoringSwaggerClient<GetAnyList200>()

    return useCallback(
        (signal?: AbortSignal) => {
            return getAnyList({ url: `/test/getAnyList`, method: 'GET', signal })
        },
        [getAnyList],
    )
}

export const getGetAnyListQueryKey = () => {
    return [`/test/getAnyList`] as const
}

export const useGetAnyListQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetAnyListHook>>>, TError = ApiError>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAnyListHook>>>, TError, TData>
}) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getGetAnyListQueryKey()

    const getAnyList = useGetAnyListHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetAnyListHook>>>> = ({ signal }) => getAnyList(signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAnyListHook>>>, TError, TData> & {
        queryKey: QueryKey
    }
}

export type GetAnyListQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetAnyListHook>>>>
export type GetAnyListQueryError = ApiError

export function useGetAnyList<TData = Awaited<ReturnType<ReturnType<typeof useGetAnyListHook>>>, TError = ApiError>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAnyListHook>>>, TError, TData>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetAnyListQueryOptions(options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useGetAnyDoubleHook = () => {
    const getAnyDouble = useMonitoringSwaggerClient<GetAnyDouble200>()

    return useCallback(
        (signal?: AbortSignal) => {
            return getAnyDouble({ url: `/test/getAnyDouble`, method: 'GET', signal })
        },
        [getAnyDouble],
    )
}

export const getGetAnyDoubleQueryKey = () => {
    return [`/test/getAnyDouble`] as const
}

export const useGetAnyDoubleQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetAnyDoubleHook>>>, TError = ApiError>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAnyDoubleHook>>>, TError, TData>
}) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getGetAnyDoubleQueryKey()

    const getAnyDouble = useGetAnyDoubleHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetAnyDoubleHook>>>> = ({ signal }) => getAnyDouble(signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAnyDoubleHook>>>, TError, TData> & {
        queryKey: QueryKey
    }
}

export type GetAnyDoubleQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetAnyDoubleHook>>>>
export type GetAnyDoubleQueryError = ApiError

export function useGetAnyDouble<TData = Awaited<ReturnType<ReturnType<typeof useGetAnyDoubleHook>>>, TError = ApiError>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAnyDoubleHook>>>, TError, TData>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetAnyDoubleQueryOptions(options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useEchoHook = () => {
    const echo = useMonitoringSwaggerClient<Echo200>()

    return useCallback(
        (params?: EchoParams, signal?: AbortSignal) => {
            return echo({ url: `/test/echo`, method: 'GET', params, signal })
        },
        [echo],
    )
}

export const getEchoQueryKey = (params?: EchoParams) => {
    return [`/test/echo`, ...(params ? [params] : [])] as const
}

export const useEchoQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useEchoHook>>>, TError = ApiError>(
    params?: EchoParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useEchoHook>>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getEchoQueryKey(params)

    const echo = useEchoHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useEchoHook>>>> = ({ signal }) => echo(params, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useEchoHook>>>, TError, TData> & {
        queryKey: QueryKey
    }
}

export type EchoQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useEchoHook>>>>
export type EchoQueryError = ApiError

export function useEcho<TData = Awaited<ReturnType<ReturnType<typeof useEchoHook>>>, TError = ApiError>(
    params?: EchoParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useEchoHook>>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useEchoQueryOptions(params, options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useListParameterTypesHook = () => {
    const listParameterTypes = useMonitoringSwaggerClient<ApiSlaParameterReadList>()

    return useCallback(
        (params: ListParameterTypesParams, signal?: AbortSignal) => {
            return listParameterTypes({ url: `/slaparams`, method: 'GET', params, signal })
        },
        [listParameterTypes],
    )
}

export const getListParameterTypesQueryKey = (params: ListParameterTypesParams) => {
    return [`/slaparams`, ...(params ? [params] : [])] as const
}

export const useListParameterTypesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useListParameterTypesHook>>>, TError = ApiError>(
    params: ListParameterTypesParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListParameterTypesHook>>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getListParameterTypesQueryKey(params)

    const listParameterTypes = useListParameterTypesHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListParameterTypesHook>>>> = ({ signal }) =>
        listParameterTypes(params, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListParameterTypesHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey }
}

export type ListParameterTypesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListParameterTypesHook>>>>
export type ListParameterTypesQueryError = ApiError

export function useListParameterTypes<TData = Awaited<ReturnType<ReturnType<typeof useListParameterTypesHook>>>, TError = ApiError>(
    params: ListParameterTypesParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListParameterTypesHook>>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useListParameterTypesQueryOptions(params, options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useGetSlaParameterHook = () => {
    const getSlaParameter = useMonitoringSwaggerClient<ApiSlaParameterRead>()

    return useCallback(
        (slaParamUuid: string, signal?: AbortSignal) => {
            return getSlaParameter({ url: `/slaparams/${slaParamUuid}`, method: 'GET', signal })
        },
        [getSlaParameter],
    )
}

export const getGetSlaParameterQueryKey = (slaParamUuid: string) => {
    return [`/slaparams/${slaParamUuid}`] as const
}

export const useGetSlaParameterQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetSlaParameterHook>>>, TError = ApiError>(
    slaParamUuid: string,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSlaParameterHook>>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getGetSlaParameterQueryKey(slaParamUuid)

    const getSlaParameter = useGetSlaParameterHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetSlaParameterHook>>>> = ({ signal }) =>
        getSlaParameter(slaParamUuid, signal)

    return { queryKey, queryFn, enabled: !!slaParamUuid, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetSlaParameterHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey }
}

export type GetSlaParameterQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetSlaParameterHook>>>>
export type GetSlaParameterQueryError = ApiError

export function useGetSlaParameter<TData = Awaited<ReturnType<ReturnType<typeof useGetSlaParameterHook>>>, TError = ApiError>(
    slaParamUuid: string,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSlaParameterHook>>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetSlaParameterQueryOptions(slaParamUuid, options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useGetSlaContractHook = () => {
    const getSlaContract = useMonitoringSwaggerClient<ApiSlaContractRead>()

    return useCallback(
        (slaContractUuid: string, signal?: AbortSignal) => {
            return getSlaContract({ url: `/slacontract/${slaContractUuid}`, method: 'GET', signal })
        },
        [getSlaContract],
    )
}

export const getGetSlaContractQueryKey = (slaContractUuid: string) => {
    return [`/slacontract/${slaContractUuid}`] as const
}

export const useGetSlaContractQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetSlaContractHook>>>, TError = ApiError>(
    slaContractUuid: string,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSlaContractHook>>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getGetSlaContractQueryKey(slaContractUuid)

    const getSlaContract = useGetSlaContractHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetSlaContractHook>>>> = ({ signal }) =>
        getSlaContract(slaContractUuid, signal)

    return { queryKey, queryFn, enabled: !!slaContractUuid, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetSlaContractHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey }
}

export type GetSlaContractQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetSlaContractHook>>>>
export type GetSlaContractQueryError = ApiError

export function useGetSlaContract<TData = Awaited<ReturnType<ReturnType<typeof useGetSlaContractHook>>>, TError = ApiError>(
    slaContractUuid: string,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSlaContractHook>>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetSlaContractQueryOptions(slaContractUuid, options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useGetSlaContractDefaultSlaParametersHook = () => {
    const getSlaContractDefaultSlaParameters = useMonitoringSwaggerClient<ApiSlaParameterReadList>()

    return useCallback(
        (slaContractUuid: string, signal?: AbortSignal) => {
            return getSlaContractDefaultSlaParameters({ url: `/slacontract/${slaContractUuid}/defaultSlaParameters`, method: 'GET', signal })
        },
        [getSlaContractDefaultSlaParameters],
    )
}

export const getGetSlaContractDefaultSlaParametersQueryKey = (slaContractUuid: string) => {
    return [`/slacontract/${slaContractUuid}/defaultSlaParameters`] as const
}

export const useGetSlaContractDefaultSlaParametersQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetSlaContractDefaultSlaParametersHook>>>,
    TError = ApiError,
>(
    slaContractUuid: string,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSlaContractDefaultSlaParametersHook>>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getGetSlaContractDefaultSlaParametersQueryKey(slaContractUuid)

    const getSlaContractDefaultSlaParameters = useGetSlaContractDefaultSlaParametersHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetSlaContractDefaultSlaParametersHook>>>> = ({ signal }) =>
        getSlaContractDefaultSlaParameters(slaContractUuid, signal)

    return { queryKey, queryFn, enabled: !!slaContractUuid, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetSlaContractDefaultSlaParametersHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey }
}

export type GetSlaContractDefaultSlaParametersQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetSlaContractDefaultSlaParametersHook>>>
>
export type GetSlaContractDefaultSlaParametersQueryError = ApiError

export function useGetSlaContractDefaultSlaParameters<
    TData = Awaited<ReturnType<ReturnType<typeof useGetSlaContractDefaultSlaParametersHook>>>,
    TError = ApiError,
>(
    slaContractUuid: string,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSlaContractDefaultSlaParametersHook>>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetSlaContractDefaultSlaParametersQueryOptions(slaContractUuid, options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useCheckOperationPermissionByMetaisCodeHook = () => {
    const checkOperationPermissionByMetaisCode = useMonitoringSwaggerClient<ApiPermissionResult>()

    return useCallback(
        (metaisCode: string, params: CheckOperationPermissionByMetaisCodeParams, signal?: AbortSignal) => {
            return checkOperationPermissionByMetaisCode({ url: `/slacontract/metaiscode/${metaisCode}/permissions`, method: 'GET', params, signal })
        },
        [checkOperationPermissionByMetaisCode],
    )
}

export const getCheckOperationPermissionByMetaisCodeQueryKey = (metaisCode: string, params: CheckOperationPermissionByMetaisCodeParams) => {
    return [`/slacontract/metaiscode/${metaisCode}/permissions`, ...(params ? [params] : [])] as const
}

export const useCheckOperationPermissionByMetaisCodeQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useCheckOperationPermissionByMetaisCodeHook>>>,
    TError = ApiError,
>(
    metaisCode: string,
    params: CheckOperationPermissionByMetaisCodeParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCheckOperationPermissionByMetaisCodeHook>>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getCheckOperationPermissionByMetaisCodeQueryKey(metaisCode, params)

    const checkOperationPermissionByMetaisCode = useCheckOperationPermissionByMetaisCodeHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useCheckOperationPermissionByMetaisCodeHook>>>> = ({ signal }) =>
        checkOperationPermissionByMetaisCode(metaisCode, params, signal)

    return { queryKey, queryFn, enabled: !!metaisCode, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useCheckOperationPermissionByMetaisCodeHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey }
}

export type CheckOperationPermissionByMetaisCodeQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useCheckOperationPermissionByMetaisCodeHook>>>
>
export type CheckOperationPermissionByMetaisCodeQueryError = ApiError

export function useCheckOperationPermissionByMetaisCode<
    TData = Awaited<ReturnType<ReturnType<typeof useCheckOperationPermissionByMetaisCodeHook>>>,
    TError = ApiError,
>(
    metaisCode: string,
    params: CheckOperationPermissionByMetaisCodeParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCheckOperationPermissionByMetaisCodeHook>>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useCheckOperationPermissionByMetaisCodeQueryOptions(metaisCode, params, options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useListSlaContractsHook = () => {
    const listSlaContracts = useMonitoringSwaggerClient<ApiSlaContractReadList>()

    return useCallback(
        (params?: ListSlaContractsParams, signal?: AbortSignal) => {
            return listSlaContracts({ url: `/slacontract/list`, method: 'GET', params, signal })
        },
        [listSlaContracts],
    )
}

export const getListSlaContractsQueryKey = (params?: ListSlaContractsParams) => {
    return [`/slacontract/list`, ...(params ? [params] : [])] as const
}

export const useListSlaContractsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useListSlaContractsHook>>>, TError = ApiError>(
    params?: ListSlaContractsParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListSlaContractsHook>>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getListSlaContractsQueryKey(params)

    const listSlaContracts = useListSlaContractsHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListSlaContractsHook>>>> = ({ signal }) => listSlaContracts(params, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListSlaContractsHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey }
}

export type ListSlaContractsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListSlaContractsHook>>>>
export type ListSlaContractsQueryError = ApiError

export function useListSlaContracts<TData = Awaited<ReturnType<ReturnType<typeof useListSlaContractsHook>>>, TError = ApiError>(
    params?: ListSlaContractsParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListSlaContractsHook>>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useListSlaContractsQueryOptions(params, options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useListCreateContractCandidatesHook = () => {
    const listCreateContractCandidates = useMonitoringSwaggerClient<ApiContractCreateObjectCandidatesList>()

    return useCallback(
        (params?: ListCreateContractCandidatesParams, signal?: AbortSignal) => {
            return listCreateContractCandidates({ url: `/slacontract/list-candidates`, method: 'GET', params, signal })
        },
        [listCreateContractCandidates],
    )
}

export const getListCreateContractCandidatesQueryKey = (params?: ListCreateContractCandidatesParams) => {
    return [`/slacontract/list-candidates`, ...(params ? [params] : [])] as const
}

export const useListCreateContractCandidatesQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useListCreateContractCandidatesHook>>>,
    TError = ApiError,
>(
    params?: ListCreateContractCandidatesParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListCreateContractCandidatesHook>>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getListCreateContractCandidatesQueryKey(params)

    const listCreateContractCandidates = useListCreateContractCandidatesHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListCreateContractCandidatesHook>>>> = ({ signal }) =>
        listCreateContractCandidates(params, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListCreateContractCandidatesHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey }
}

export type ListCreateContractCandidatesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListCreateContractCandidatesHook>>>>
export type ListCreateContractCandidatesQueryError = ApiError

export function useListCreateContractCandidates<
    TData = Awaited<ReturnType<ReturnType<typeof useListCreateContractCandidatesHook>>>,
    TError = ApiError,
>(
    params?: ListCreateContractCandidatesParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListCreateContractCandidatesHook>>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useListCreateContractCandidatesQueryOptions(params, options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useCheckRequiredSlaParametersHook = () => {
    const checkRequiredSlaParameters = useMonitoringSwaggerClient<ApiServicesSlaParameters>()

    return useCallback(
        (params: CheckRequiredSlaParametersParams, signal?: AbortSignal) => {
            return checkRequiredSlaParameters({ url: `/slacontract/check-required-sla-parameters`, method: 'GET', params, signal })
        },
        [checkRequiredSlaParameters],
    )
}

export const getCheckRequiredSlaParametersQueryKey = (params: CheckRequiredSlaParametersParams) => {
    return [`/slacontract/check-required-sla-parameters`, ...(params ? [params] : [])] as const
}

export const useCheckRequiredSlaParametersQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useCheckRequiredSlaParametersHook>>>,
    TError = ApiError,
>(
    params: CheckRequiredSlaParametersParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCheckRequiredSlaParametersHook>>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getCheckRequiredSlaParametersQueryKey(params)

    const checkRequiredSlaParameters = useCheckRequiredSlaParametersHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useCheckRequiredSlaParametersHook>>>> = ({ signal }) =>
        checkRequiredSlaParameters(params, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useCheckRequiredSlaParametersHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey }
}

export type CheckRequiredSlaParametersQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCheckRequiredSlaParametersHook>>>>
export type CheckRequiredSlaParametersQueryError = ApiError

export function useCheckRequiredSlaParameters<TData = Awaited<ReturnType<ReturnType<typeof useCheckRequiredSlaParametersHook>>>, TError = ApiError>(
    params: CheckRequiredSlaParametersParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCheckRequiredSlaParametersHook>>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useCheckRequiredSlaParametersQueryOptions(params, options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useListRelatedParameterTypesHook = () => {
    const listRelatedParameterTypes = useMonitoringSwaggerClient<ApiParameterTypesList>()

    return useCallback(
        (
            parameterTypeCode: string,
            relatedParameterTypeType: 'SLA' | 'MONITORING',
            params?: ListRelatedParameterTypesParams,
            signal?: AbortSignal,
        ) => {
            return listRelatedParameterTypes({
                url: `/paramtypes/${parameterTypeCode}/related/${relatedParameterTypeType}`,
                method: 'GET',
                params,
                signal,
            })
        },
        [listRelatedParameterTypes],
    )
}

export const getListRelatedParameterTypesQueryKey = (
    parameterTypeCode: string,
    relatedParameterTypeType: 'SLA' | 'MONITORING',
    params?: ListRelatedParameterTypesParams,
) => {
    return [`/paramtypes/${parameterTypeCode}/related/${relatedParameterTypeType}`, ...(params ? [params] : [])] as const
}

export const useListRelatedParameterTypesQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useListRelatedParameterTypesHook>>>,
    TError = ApiError,
>(
    parameterTypeCode: string,
    relatedParameterTypeType: 'SLA' | 'MONITORING',
    params?: ListRelatedParameterTypesParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListRelatedParameterTypesHook>>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getListRelatedParameterTypesQueryKey(parameterTypeCode, relatedParameterTypeType, params)

    const listRelatedParameterTypes = useListRelatedParameterTypesHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListRelatedParameterTypesHook>>>> = ({ signal }) =>
        listRelatedParameterTypes(parameterTypeCode, relatedParameterTypeType, params, signal)

    return { queryKey, queryFn, enabled: !!(parameterTypeCode && relatedParameterTypeType), ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListRelatedParameterTypesHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey }
}

export type ListRelatedParameterTypesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListRelatedParameterTypesHook>>>>
export type ListRelatedParameterTypesQueryError = ApiError

export function useListRelatedParameterTypes<TData = Awaited<ReturnType<ReturnType<typeof useListRelatedParameterTypesHook>>>, TError = ApiError>(
    parameterTypeCode: string,
    relatedParameterTypeType: 'SLA' | 'MONITORING',
    params?: ListRelatedParameterTypesParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListRelatedParameterTypesHook>>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useListRelatedParameterTypesQueryOptions(parameterTypeCode, relatedParameterTypeType, params, options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useGetOlaContractHook = () => {
    const getOlaContract = useMonitoringSwaggerClient<ApiOlaContractData>()

    return useCallback(
        (olaContractUuid: string, signal?: AbortSignal) => {
            return getOlaContract({ url: `/olacontract/${olaContractUuid}`, method: 'GET', signal })
        },
        [getOlaContract],
    )
}

export const getGetOlaContractQueryKey = (olaContractUuid: string) => {
    return [`/olacontract/${olaContractUuid}`] as const
}

export const useGetOlaContractQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetOlaContractHook>>>, TError = ApiError>(
    olaContractUuid: string,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOlaContractHook>>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getGetOlaContractQueryKey(olaContractUuid)

    const getOlaContract = useGetOlaContractHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetOlaContractHook>>>> = ({ signal }) =>
        getOlaContract(olaContractUuid, signal)

    return { queryKey, queryFn, enabled: !!olaContractUuid, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetOlaContractHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey }
}

export type GetOlaContractQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetOlaContractHook>>>>
export type GetOlaContractQueryError = ApiError

export function useGetOlaContract<TData = Awaited<ReturnType<ReturnType<typeof useGetOlaContractHook>>>, TError = ApiError>(
    olaContractUuid: string,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOlaContractHook>>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetOlaContractQueryOptions(olaContractUuid, options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useListOlaContractListHook = () => {
    const listOlaContractList = useMonitoringSwaggerClient<ApiOlaContractDataList>()

    return useCallback(
        (params?: ListOlaContractListParams, signal?: AbortSignal) => {
            return listOlaContractList({ url: `/olacontract/list`, method: 'GET', params, signal })
        },
        [listOlaContractList],
    )
}

export const getListOlaContractListQueryKey = (params?: ListOlaContractListParams) => {
    return [`/olacontract/list`, ...(params ? [params] : [])] as const
}

export const useListOlaContractListQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useListOlaContractListHook>>>, TError = ApiError>(
    params?: ListOlaContractListParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListOlaContractListHook>>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getListOlaContractListQueryKey(params)

    const listOlaContractList = useListOlaContractListHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListOlaContractListHook>>>> = ({ signal }) =>
        listOlaContractList(params, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListOlaContractListHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey }
}

export type ListOlaContractListQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListOlaContractListHook>>>>
export type ListOlaContractListQueryError = ApiError

export function useListOlaContractList<TData = Awaited<ReturnType<ReturnType<typeof useListOlaContractListHook>>>, TError = ApiError>(
    params?: ListOlaContractListParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListOlaContractListHook>>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useListOlaContractListQueryOptions(params, options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useFindActiveMonitoringLogFailNoteHook = () => {
    const findActiveMonitoringLogFailNote = useMonitoringSwaggerClient<ApiActiveMonitoringLogFailNoteList>()

    return useCallback(
        (params: FindActiveMonitoringLogFailNoteParams, signal?: AbortSignal) => {
            return findActiveMonitoringLogFailNote({ url: `/activeMonitoring/logFailNote/find`, method: 'GET', params, signal })
        },
        [findActiveMonitoringLogFailNote],
    )
}

export const getFindActiveMonitoringLogFailNoteQueryKey = (params: FindActiveMonitoringLogFailNoteParams) => {
    return [`/activeMonitoring/logFailNote/find`, ...(params ? [params] : [])] as const
}

export const useFindActiveMonitoringLogFailNoteQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useFindActiveMonitoringLogFailNoteHook>>>,
    TError = ApiError,
>(
    params: FindActiveMonitoringLogFailNoteParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFindActiveMonitoringLogFailNoteHook>>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getFindActiveMonitoringLogFailNoteQueryKey(params)

    const findActiveMonitoringLogFailNote = useFindActiveMonitoringLogFailNoteHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useFindActiveMonitoringLogFailNoteHook>>>> = ({ signal }) =>
        findActiveMonitoringLogFailNote(params, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useFindActiveMonitoringLogFailNoteHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey }
}

export type FindActiveMonitoringLogFailNoteQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useFindActiveMonitoringLogFailNoteHook>>>>
export type FindActiveMonitoringLogFailNoteQueryError = ApiError

export function useFindActiveMonitoringLogFailNote<
    TData = Awaited<ReturnType<ReturnType<typeof useFindActiveMonitoringLogFailNoteHook>>>,
    TError = ApiError,
>(
    params: FindActiveMonitoringLogFailNoteParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFindActiveMonitoringLogFailNoteHook>>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useFindActiveMonitoringLogFailNoteQueryOptions(params, options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useFindActiveMonitoringLogHook = () => {
    const findActiveMonitoringLog = useMonitoringSwaggerClient<ApiActiveMonitoringLogList>()

    return useCallback(
        (params: FindActiveMonitoringLogParams, signal?: AbortSignal) => {
            return findActiveMonitoringLog({ url: `/activeMonitoring/log/find`, method: 'GET', params, signal })
        },
        [findActiveMonitoringLog],
    )
}

export const getFindActiveMonitoringLogQueryKey = (params: FindActiveMonitoringLogParams) => {
    return [`/activeMonitoring/log/find`, ...(params ? [params] : [])] as const
}

export const useFindActiveMonitoringLogQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useFindActiveMonitoringLogHook>>>,
    TError = ApiError,
>(
    params: FindActiveMonitoringLogParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFindActiveMonitoringLogHook>>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getFindActiveMonitoringLogQueryKey(params)

    const findActiveMonitoringLog = useFindActiveMonitoringLogHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useFindActiveMonitoringLogHook>>>> = ({ signal }) =>
        findActiveMonitoringLog(params, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useFindActiveMonitoringLogHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey }
}

export type FindActiveMonitoringLogQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useFindActiveMonitoringLogHook>>>>
export type FindActiveMonitoringLogQueryError = ApiError

export function useFindActiveMonitoringLog<TData = Awaited<ReturnType<ReturnType<typeof useFindActiveMonitoringLogHook>>>, TError = ApiError>(
    params: FindActiveMonitoringLogParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFindActiveMonitoringLogHook>>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useFindActiveMonitoringLogQueryOptions(params, options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useFindActiveMonitoringLogByIntervalHook = () => {
    const findActiveMonitoringLogByInterval = useMonitoringSwaggerClient<ApiActiveMonitoringLogList>()

    return useCallback(
        (id: number, params: FindActiveMonitoringLogByIntervalParams, signal?: AbortSignal) => {
            return findActiveMonitoringLogByInterval({ url: `/activeMonitoring/log/find/${id}/byInterval`, method: 'GET', params, signal })
        },
        [findActiveMonitoringLogByInterval],
    )
}

export const getFindActiveMonitoringLogByIntervalQueryKey = (id: number, params: FindActiveMonitoringLogByIntervalParams) => {
    return [`/activeMonitoring/log/find/${id}/byInterval`, ...(params ? [params] : [])] as const
}

export const useFindActiveMonitoringLogByIntervalQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useFindActiveMonitoringLogByIntervalHook>>>,
    TError = ApiError,
>(
    id: number,
    params: FindActiveMonitoringLogByIntervalParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFindActiveMonitoringLogByIntervalHook>>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getFindActiveMonitoringLogByIntervalQueryKey(id, params)

    const findActiveMonitoringLogByInterval = useFindActiveMonitoringLogByIntervalHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useFindActiveMonitoringLogByIntervalHook>>>> = ({ signal }) =>
        findActiveMonitoringLogByInterval(id, params, signal)

    return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useFindActiveMonitoringLogByIntervalHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey }
}

export type FindActiveMonitoringLogByIntervalQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useFindActiveMonitoringLogByIntervalHook>>>
>
export type FindActiveMonitoringLogByIntervalQueryError = ApiError

export function useFindActiveMonitoringLogByInterval<
    TData = Awaited<ReturnType<ReturnType<typeof useFindActiveMonitoringLogByIntervalHook>>>,
    TError = ApiError,
>(
    id: number,
    params: FindActiveMonitoringLogByIntervalParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFindActiveMonitoringLogByIntervalHook>>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useFindActiveMonitoringLogByIntervalQueryOptions(id, params, options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useFindActiveMonitoringLogByInterval1Hook = () => {
    const findActiveMonitoringLogByInterval1 = useMonitoringSwaggerClient<ApiActiveMonitoringLogList>()

    return useCallback(
        (params: FindActiveMonitoringLogByInterval1Params, signal?: AbortSignal) => {
            return findActiveMonitoringLogByInterval1({ url: `/activeMonitoring/log/find/byInterval`, method: 'GET', params, signal })
        },
        [findActiveMonitoringLogByInterval1],
    )
}

export const getFindActiveMonitoringLogByInterval1QueryKey = (params: FindActiveMonitoringLogByInterval1Params) => {
    return [`/activeMonitoring/log/find/byInterval`, ...(params ? [params] : [])] as const
}

export const useFindActiveMonitoringLogByInterval1QueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useFindActiveMonitoringLogByInterval1Hook>>>,
    TError = ApiError,
>(
    params: FindActiveMonitoringLogByInterval1Params,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFindActiveMonitoringLogByInterval1Hook>>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getFindActiveMonitoringLogByInterval1QueryKey(params)

    const findActiveMonitoringLogByInterval1 = useFindActiveMonitoringLogByInterval1Hook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useFindActiveMonitoringLogByInterval1Hook>>>> = ({ signal }) =>
        findActiveMonitoringLogByInterval1(params, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useFindActiveMonitoringLogByInterval1Hook>>>,
        TError,
        TData
    > & { queryKey: QueryKey }
}

export type FindActiveMonitoringLogByInterval1QueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useFindActiveMonitoringLogByInterval1Hook>>>
>
export type FindActiveMonitoringLogByInterval1QueryError = ApiError

export function useFindActiveMonitoringLogByInterval1<
    TData = Awaited<ReturnType<ReturnType<typeof useFindActiveMonitoringLogByInterval1Hook>>>,
    TError = ApiError,
>(
    params: FindActiveMonitoringLogByInterval1Params,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFindActiveMonitoringLogByInterval1Hook>>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useFindActiveMonitoringLogByInterval1QueryOptions(params, options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useFindAvaliabilityHook = () => {
    const findAvaliability = useMonitoringSwaggerClient<ApiActiveMonitoringAvaliability>()

    return useCallback(
        (uuid: string, signal?: AbortSignal) => {
            return findAvaliability({ url: `/activeMonitoring/log/avaliability/${uuid}`, method: 'GET', signal })
        },
        [findAvaliability],
    )
}

export const getFindAvaliabilityQueryKey = (uuid: string) => {
    return [`/activeMonitoring/log/avaliability/${uuid}`] as const
}

export const useFindAvaliabilityQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useFindAvaliabilityHook>>>, TError = ApiError>(
    uuid: string,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFindAvaliabilityHook>>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getFindAvaliabilityQueryKey(uuid)

    const findAvaliability = useFindAvaliabilityHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useFindAvaliabilityHook>>>> = ({ signal }) => findAvaliability(uuid, signal)

    return { queryKey, queryFn, enabled: !!uuid, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useFindAvaliabilityHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey }
}

export type FindAvaliabilityQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useFindAvaliabilityHook>>>>
export type FindAvaliabilityQueryError = ApiError

export function useFindAvaliability<TData = Awaited<ReturnType<ReturnType<typeof useFindAvaliabilityHook>>>, TError = ApiError>(
    uuid: string,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFindAvaliabilityHook>>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useFindAvaliabilityQueryOptions(uuid, options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useGetHook = () => {
    const get = useMonitoringSwaggerClient<ApiActiveMonitoringCfg>()

    return useCallback(
        (id: number, signal?: AbortSignal) => {
            return get({ url: `/activeMonitoring/cfg/get/${id}`, method: 'GET', signal })
        },
        [get],
    )
}

export const getGetQueryKey = (id: number) => {
    return [`/activeMonitoring/cfg/get/${id}`] as const
}

export const useGetQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetHook>>>, TError = ApiError>(
    id: number,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetHook>>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getGetQueryKey(id)

    const get = useGetHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetHook>>>> = ({ signal }) => get(id, signal)

    return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey }
}

export type GetQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetHook>>>>
export type GetQueryError = ApiError

export function useGet<TData = Awaited<ReturnType<ReturnType<typeof useGetHook>>>, TError = ApiError>(
    id: number,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetHook>>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useGetQueryOptions(id, options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useFindActiveMonitoringCfgHook = () => {
    const findActiveMonitoringCfg = useMonitoringSwaggerClient<ApiActiveMonitoringCfgList>()

    return useCallback(
        (params?: FindActiveMonitoringCfgParams, signal?: AbortSignal) => {
            return findActiveMonitoringCfg({ url: `/activeMonitoring/cfg/find`, method: 'GET', params, signal })
        },
        [findActiveMonitoringCfg],
    )
}

export const getFindActiveMonitoringCfgQueryKey = (params?: FindActiveMonitoringCfgParams) => {
    return [`/activeMonitoring/cfg/find`, ...(params ? [params] : [])] as const
}

export const useFindActiveMonitoringCfgQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useFindActiveMonitoringCfgHook>>>,
    TError = ApiError,
>(
    params?: FindActiveMonitoringCfgParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFindActiveMonitoringCfgHook>>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getFindActiveMonitoringCfgQueryKey(params)

    const findActiveMonitoringCfg = useFindActiveMonitoringCfgHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useFindActiveMonitoringCfgHook>>>> = ({ signal }) =>
        findActiveMonitoringCfg(params, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useFindActiveMonitoringCfgHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey }
}

export type FindActiveMonitoringCfgQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useFindActiveMonitoringCfgHook>>>>
export type FindActiveMonitoringCfgQueryError = ApiError

export function useFindActiveMonitoringCfg<TData = Awaited<ReturnType<ReturnType<typeof useFindActiveMonitoringCfgHook>>>, TError = ApiError>(
    params?: FindActiveMonitoringCfgParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFindActiveMonitoringCfgHook>>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useFindActiveMonitoringCfgQueryOptions(params, options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useCallIsvsEndpointHook = () => {
    const callIsvsEndpoint = useMonitoringSwaggerClient<ApiActiveMonitoringResult>()

    return useCallback(
        (id: number, signal?: AbortSignal) => {
            return callIsvsEndpoint({ url: `/activeMonitoring/cfg/callIsvsEndpoint/${id}`, method: 'GET', signal })
        },
        [callIsvsEndpoint],
    )
}

export const getCallIsvsEndpointQueryKey = (id: number) => {
    return [`/activeMonitoring/cfg/callIsvsEndpoint/${id}`] as const
}

export const useCallIsvsEndpointQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useCallIsvsEndpointHook>>>, TError = ApiError>(
    id: number,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCallIsvsEndpointHook>>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getCallIsvsEndpointQueryKey(id)

    const callIsvsEndpoint = useCallIsvsEndpointHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useCallIsvsEndpointHook>>>> = ({ signal }) => callIsvsEndpoint(id, signal)

    return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useCallIsvsEndpointHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey }
}

export type CallIsvsEndpointQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCallIsvsEndpointHook>>>>
export type CallIsvsEndpointQueryError = ApiError

export function useCallIsvsEndpoint<TData = Awaited<ReturnType<ReturnType<typeof useCallIsvsEndpointHook>>>, TError = ApiError>(
    id: number,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCallIsvsEndpointHook>>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useCallIsvsEndpointQueryOptions(id, options)

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

    query.queryKey = queryOptions.queryKey

    return query
}

export const use_DeleteHook = () => {
    const _delete = useMonitoringSwaggerClient<void>()

    return useCallback(
        (id: number) => {
            return _delete({ url: `/activeMonitoring/cfg/delete/${id}`, method: 'DELETE' })
        },
        [_delete],
    )
}

export const useDeleteMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof use_DeleteHook>>>, TError, { id: number }, TContext>
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof use_DeleteHook>>>, TError, { id: number }, TContext> => {
    const { mutation: mutationOptions } = options ?? {}

    const _delete = use_DeleteHook()

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof use_DeleteHook>>>, { id: number }> = (props) => {
        const { id } = props ?? {}

        return _delete(id)
    }

    return { mutationFn, ...mutationOptions }
}

export type _DeleteMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof use_DeleteHook>>>>

export type _DeleteMutationError = ApiError

export const useDelete = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof use_DeleteHook>>>, TError, { id: number }, TContext>
}): UseMutationResult<Awaited<ReturnType<ReturnType<typeof use_DeleteHook>>>, TError, { id: number }, TContext> => {
    const mutationOptions = useDeleteMutationOptions(options)

    return useMutation(mutationOptions)
}
